var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125.906,
    height: 146.991,
    viewBox: "0 0 125.906 146.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.n{fill:#fff;}.a{opacity:0.1;}.b{clip-path:url(#c);}.c{fill:#009636;}.d{fill:#f9fcf8;}.e{fill:#dde2dd;}.f{fill:#b8c2b9;}.g{fill:#4a6845;}.h{fill:#a0b29d;}.i{fill:#64795f;}.j{fill:#fdfdfd;}.k{fill:#f5223b;}.l{fill:#d65a83;}.m{fill:#8a8a8a;}.o{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 125.906,
    height: 146.991,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,20V64.339h93.6V20",
    transform: "translate(-20 -20)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15122 -8669.333)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(1, 0, 0, 1, 15122, 8669.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H107.906V128.991H0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15136.912 8677.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.806 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.773,144.678c0,1.148-.011,2.3.008,3.445.007.348-.069.5-.453.488-1.049-.021-2.1-.013-3.151,0-.322,0-.429-.11-.427-.429q.015-3.545,0-7.089c0-.3.089-.409.391-.406,1.084.013,2.166.018,3.25,0,.305,0,.391.092.388.391C66.763,142.283,66.773,143.481,66.773,144.678Z",
    transform: "translate(-55.73 -120.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M250.744,174.131a1.626,1.626,0,0,1,.865.2c.233.1.138.2,0,.3-.217-.018-.356-.281-.606-.22,0,.046-.01.067,0,.077a.32.32,0,0,0,.094.108c.547.264.576.69.381,1.192a3.289,3.289,0,0,0-.117.374.8.8,0,0,0,.443,1.021,1.22,1.22,0,0,1,.757.941c.066.376.207.785.81.783-.2-.291-.53-.414-.558-.732a1.393,1.393,0,0,0-.9-1.181c-.057-.164.233-.353.031-.46-.182-.1-.136.189-.232.269-.112-.222-.25-.44-.09-.7l.48.2a1.34,1.34,0,0,0,1.388,1.079c.407.015.816.013,1.225.007.312,0,.6,0,.552.532.192-.287.261-.488.11-.68a.455.455,0,0,0-.5-.1,3.633,3.633,0,0,1-1.55-.1c-.243-.046-.476-.145-.524-.442h0c.238-.082.184-.258.141-.434a.464.464,0,0,1,.153-.557c.033.066.066.131.1.2.059.626.3.849,1,.887a6.009,6.009,0,0,1,1.123.1.7.7,0,0,1,.483,1.059c-.069.135-.322.278-.163.4.184.148.31-.153.478-.227.067-.03.087-.164.128-.253l.108.1a.973.973,0,0,1-.721,1.156.346.346,0,0,1-.388-.143c-.1-.176.067-.163.174-.182.072-.013.123-.069.085-.135a.235.235,0,0,0-.153-.1.385.385,0,0,0-.384.158c-.164.214.007.36.107.519-.176.018-.437-.048-.3.292l0,0c-.136.008-.315-.163-.391.1-.145.236-.378.2-.6.2-.057-.317-.307-.3-.535-.291a.735.735,0,0,1-.847-.647,1.991,1.991,0,0,0-1.049-1.489.9.9,0,0,1-.33-1.232,4.711,4.711,0,0,0,.189-.608c.058-.271.015-.35-.235-.56a1.365,1.365,0,0,1-.327,1.287,3.68,3.68,0,0,1-.209-1.184C250.538,174.723,250.64,174.428,250.744,174.131Zm3.041,4.337c-.575.276.085.532-.015.846.013-.575.365.046.448-.179-.048-.238-.094-.478-.143-.716-.02-.1-.033-.215-.166-.19s-.107.146-.125.24Zm.709-.415c-.067-.079.148-.276-.079-.292-.2-.015-.25.176-.225.355.028.209.061.419.1.624.026.126.079.291.235.256.2-.043.146-.233.112-.368C254.6,178.443,254.435,178.29,254.495,178.052Zm.609.018c-.053-.1,0-.312-.166-.3-.19.01-.228.209-.243.371a.176.176,0,0,0,.207.209A.212.212,0,0,0,255.1,178.07Zm-4.337-3.335.028,0-.011-.028Z",
    transform: "translate(-212.597 -148.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M338.6,148.274c-.78-.112-1.572-.19-2.031-.977a.424.424,0,0,0-.327-.2c-.023-.069-.044-.136-.067-.205-.021.011-.061.023-.061.034,0,.089.066.128.128.169a1.552,1.552,0,0,1,.041.384c-.053.356-.33.465-.581.205-.488-.5-.949-1.03-1.412-1.553-.12-.136-.214-.291-.412-.317l0,0a.516.516,0,0,0-.4-.3l0,0a1.332,1.332,0,0,0-.08-.177c-.066-.1-.153-.207-.054-.307.135-.136.235.011.33.087.189.149.371.309.635.529-.1-.629-.828-.685-.885-1.325a10.74,10.74,0,0,1,2.452,2.265,10.191,10.191,0,0,0-2.439-2.728.646.646,0,0,1,.586.115c.14.064.215.256.435.212-.051-.32-.443-.365-.537-.644.22-.146.322.034.435.125a13.229,13.229,0,0,1,2.345,2.565c.181.241.282.563.621.66,0,.13,0,.261,0,.391l-.01.01c-.305-.059-.361-.355-.526-.548a6.468,6.468,0,0,0-1.343-1.524.23.23,0,0,0-.2-.2l-.015-.018.016.015a.258.258,0,0,0,.2.2,22.508,22.508,0,0,0,1.66,2.348.38.38,0,0,0,.521.122c.159-.128,0-.3-.067-.438a.674.674,0,0,0-.245-.355,10.323,10.323,0,0,0-2.6-3.283c-.11-.09-.386-.149-.246-.342s.324,0,.457.108a10.491,10.491,0,0,1,2.775,3.527,4.344,4.344,0,0,0,.8,1.171C338.54,148.149,338.573,148.211,338.6,148.274Zm-2.746-.946a3.707,3.707,0,0,0-1.406-1.517A6.859,6.859,0,0,0,335.858,147.328Z",
    transform: "translate(-281.858 -122.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M107.589,143.4a.394.394,0,0,0,.215-.4c-.112-.931-.016-1.867-.059-2.8-.021-.47.161-.662.65-.7a15.357,15.357,0,0,1,3.33.015,1.769,1.769,0,0,1,.281.084.423.423,0,0,1-.034.085c-1.2,0-2.394,0-3.591-.018-.282,0-.369.108-.368.378q.01,3.542,0,7.086c0,.31.113.389.4.386,1-.013,2-.028,3,0,.447.013.576-.113.571-.568-.02-2.411,0-4.821,0-7.234a1.343,1.343,0,0,1,.182.847q0,3.316,0,6.631a.46.46,0,0,1-.475.5,25.122,25.122,0,0,1-2.941.08,3.424,3.424,0,0,1-.677-.1.384.384,0,0,1-.328-.422c.007-.719-.028-1.443.031-2.159.031-.384.028-.631-.425-.639-.021-.025-.043-.049-.066-.074.026-.072.064-.133.149-.143l.105-.049-.023-.015.015-.023c.074-.01.182.007.181-.09,0-.054-.1-.105-.149-.159C107.576,143.728,107.582,143.564,107.589,143.4Z",
    transform: "translate(-92.955 -119.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.125,217.692c-.049.294-.1.588-.146.882a18.161,18.161,0,0,0-.473,2.173c-.386.248-.386-.016-.381-.287a7.546,7.546,0,0,0,.324-1.7,8.893,8.893,0,0,0-.966,1.575,1.347,1.347,0,0,0-.151.25c-.076.212-.2.346-.437.281s-.256-.253-.236-.468a2.476,2.476,0,0,0-.034-.438c-.072-.48-.143-.957-.215-1.437a7.343,7.343,0,0,0-.486,2.028l-.084.282-.389.015c.2-.98.4-1.959.58-2.941.039-.21.122-.325.342-.335.273-.013.264.192.292.365.125.772.245,1.544.415,2.329a18.769,18.769,0,0,0,1.3-2.342c.149-.164.279-.361.537-.363l.112-.039C95.06,217.577,95.092,217.635,95.125,217.692Zm-.553.795c-.007-.011-.011-.025-.018-.036-.008.01-.023.02-.023.031s.01.025.016.036C94.555,218.507,94.564,218.5,94.572,218.487Z",
    transform: "translate(-79.717 -185.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M305.953,132.508l.325.169a1.671,1.671,0,0,1-1.181.6.6.6,0,0,1-.5-.151c-.09-.08-.153-.2-.066-.3s.169,0,.241.058c.159.135.379.174.48.011.138-.223-.138-.292-.271-.373a9.2,9.2,0,0,0-4.555-1.2c-.254-.008-.463.064-.525.338-.074.32.192.328.388.386,1.716.507,2.058,1.869,2.1,3.278.016.5-.453.808-.729,1.186-.041.056-.12.082-.166.025a.2.2,0,0,1-.026-.176,1.227,1.227,0,0,1,.166-.24,2.576,2.576,0,0,0-.859-3.468,1.023,1.023,0,0,0-.238-.049l0,0-.2-.1,0,0a.328.328,0,0,0-.2-.191c-.695-.287-.78-.67-.284-1.276.621,0,1.24,0,1.861-.007a2.576,2.576,0,0,0,.987.19l.194.007a7.7,7.7,0,0,0,1.48.489l.294.1a2.835,2.835,0,0,0,.985.591C305.753,132.446,305.853,132.477,305.953,132.508Z",
    transform: "translate(-253.635 -112.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M325.944,189.64c-.718.529-.982.514-1.688-.016a11.185,11.185,0,0,0-1.578-1.067l0,0-.2-.1,0,0c-.034-.164-.156-.2-.3-.2l0,0c-.067-.164-.133-.33-.2-.494.074-.026.158-.056.125-.154s-.133-.118-.223-.14l-.016-.018.02.016.1.3-.3,0,0,0c-.026-.141-.15-.2-.233-.3-.184-.21-.319-.291-.378.082-.02.126-.076.282-.233.263s-.125-.2-.163-.317c-.079-.243-.076-.517-.271-.716.008-.094.018-.187.028-.3.366.176.154.617.435.81a2.268,2.268,0,0,0-.143-1.79c-.181.084.064.278-.123.373a3.015,3.015,0,0,0-.276-.507c-.248-.31.148-.305.227-.417.113-.161.174.079.238.164a.4.4,0,0,1,.105.218c-.026,1.051.859,1.286,1.524,1.726q1.33.879,2.644,1.788a.906.906,0,0,0,.532.215C325.721,189.254,325.833,189.447,325.944,189.64Zm-1.393-.2-.02-.02.02.02c.036.054.061.13.112.154.256.13.586.259.757-.013s-.192-.361-.36-.48c-.9-.626-1.81-1.238-2.719-1.851-.1-.066-.189-.2-.356-.105.026.128.133.177.223.241q1.237.887,2.475,1.775c.077.054.2.117.141.217C324.788,189.438,324.645,189.425,324.552,189.443Zm-1.411-.949c.194.174.253.307.486.287C323.557,188.593,323.442,188.532,323.141,188.494Zm1.153.695c-.025-.021-.054-.062-.092-.074s-.1.025-.077.076a.168.168,0,0,0,.09.09C324.266,189.3,324.3,189.263,324.294,189.189Zm-1.879-1.3c0-.013,0-.028,0-.041l-.062.023c.008.012.015.028.025.031S322.4,187.89,322.415,187.885Zm.394.269-.03-.026c-.008.02-.018.038-.026.057.013,0,.03.01.038,0S322.8,188.167,322.809,188.154Zm1.048.834c.013-.007.033-.01.038-.02s-.007-.028-.01-.043l-.061.035C323.836,188.97,323.846,188.98,323.857,188.988Zm-2.274-1.747a.263.263,0,0,1,0,.036l.054-.016c-.008-.01-.013-.025-.023-.028S321.6,187.238,321.583,187.241Z",
    transform: "translate(-270.951 -157.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M291.559,239.806c.348.087.7.179,1.048.256.122.026.273.084.351-.067.061-.117-.033-.222-.1-.31-.427-.562-.516-1.291-.933-1.861.519.149.644.621.773,1.025s.42.7.511,1.107c0,.016.007.038.016.044a.9.9,0,0,0,.841.044c.327-.12.833.151.969-.4.02-.082.03-.2.122-.161.637.266.282-.228.355-.427.151-.422-.023-.841.038-1.261.039-.266-.051-.407-.325-.2-.076.057-.154.159-.245.051s0-.217.085-.291a.517.517,0,0,1,.6-.046.414.414,0,0,1,.2.46,7.065,7.065,0,0,0,.015,1.591.749.749,0,0,1-.2.631c-.061,0-.122,0-.184.008-.388-.025-.665.24-.987.384a11.577,11.577,0,0,1-3.04-.19.237.237,0,0,0-.209-.189c-.163,0-.325-.012-.488-.018a7.094,7.094,0,0,1-.181-2.549c0-.258.4-.383.619-.228a.23.23,0,0,1,.12.248c-.044.163-.141.066-.227.038-.184-.061-.284,0-.271.207.036.576.082,1.153.1,1.731.007.23.085.36.269.189.343-.319.312-.025.353.181l-.018.023Z",
    transform: "translate(-246.134 -201.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M39.433,220.054a1.427,1.427,0,0,1-2.222.563.775.775,0,0,1-.218-.429c-.028-.135-.11-.31.089-.379s.228.1.3.236a.9.9,0,0,0,1.363.342c.34-.243.351-.563,0-.788-.246-.158-.529-.258-.79-.394a.881.881,0,0,1-.58-.974c.085-.493.45-.647.883-.7a1.443,1.443,0,0,1,1.03.187,1.263,1.263,0,0,1,.186.225c.084.166.271.386.082.521-.241.174-.281-.128-.4-.266a.938.938,0,0,0-1.067-.266.476.476,0,0,0-.328.4.452.452,0,0,0,.291.466c.217.113.44.213.665.309A1.032,1.032,0,0,1,39.433,220.054Z",
    transform: "translate(-34.168 -185.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M263.957,158.2c0-.1,0-.189,0-.284-.018-.376-.394-.752.056-1.122a.332.332,0,0,0-.434.217,2.532,2.532,0,0,0-.126.468.419.419,0,0,1-.261-.5.394.394,0,0,1,.365-.345,1.377,1.377,0,0,0,.59-.227.207.207,0,0,1,.305.038c.107.161-.156.133-.145.258a1.326,1.326,0,0,0,.936-.2c.1-.057.235-.087.315.021s0,.215-.1.284a.46.46,0,0,0-.22.31c-.035.034-.071.067-.105.1-.168-.064-.246-.315-.59-.209.6.384.5.949.5,1.485a.266.266,0,0,1-.291.3,1.515,1.515,0,0,0-.3-1.511c-.1-.118-.258-.232-.378-.115-.161.159.053.238.148.327a.79.79,0,0,1,.128,1.163,7.312,7.312,0,0,1-1.166,1.176c-.78.754-.849.911-.509,1.915h0a1.427,1.427,0,0,1-.084-1.923,11.35,11.35,0,0,1,1.268-1.214C263.964,158.532,264.305,158.419,263.957,158.2Z",
    transform: "translate(-222.476 -133.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M330.361,121.034l-.575-.205a1.129,1.129,0,0,0-.512-.368.766.766,0,0,0-.392-.222.5.5,0,0,1-.414-.388.913.913,0,0,0,.266-.726c-.186.328-.392.468-.457.716l-.189-.09v-.921a.836.836,0,0,0-.394.818c-.064,0-.128,0-.192,0l-.291-.1c0-.059,0-.12,0-.179.305-.079.368-.327.406-.591a.277.277,0,0,0,.184-.3.238.238,0,0,0,.182-.2c.015-.264.023-.535.407-.494a5.24,5.24,0,0,1,.036,1.273c.488-.241.576-.852,1.141-.772h0c-.176.452-.355.9-.522,1.355-.064.172-.107.374.115.46.2.076.284-.1.363-.245q.323-.586.642-1.176c.3.253.785.3.885.782a1.275,1.275,0,0,1-.141-.038c-.184-.077-.323-.4-.571-.105-.187.22-.2.4.125.509.069.023.036.117-.008.167-.066.076-.158.159-.243.054-.223-.274-.327-.064-.43.1-.14.222-.013.363.169.481S330.381,120.738,330.361,121.034Z",
    transform: "translate(-276.76 -101.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M363.375,153.538a.335.335,0,0,1,.133-.5.253.253,0,0,0,.105-.342c-.087-.156-.217-.1-.343-.051-.105.041-.21.117-.324.046a.3.3,0,0,1-.117-.145.1.1,0,0,1,.09-.138c.645-.015,1.169-.517,1.834-.452.034.066.067.133.1.2-.194.476-.65.723-.957,1.1-.11.136-.3.261-.148.46.128.171.3.066.447,0,.415-.187.829-.381,1.243-.571a1.293,1.293,0,0,1-.108.588c-.145.222-.289.443-.5.762.378-.136.7-.1.811-.46.278.08.361.238.192.493a1.376,1.376,0,0,0-.747.19,2.092,2.092,0,0,1-1.023.287c.077-.4.453-.668.506-1.085a.337.337,0,0,0-.383.072c-.346.4-.506.233-.631-.169A1.149,1.149,0,0,0,363.375,153.538Z",
    transform: "translate(-306.525 -130.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M43.517,220.669a1.034,1.034,0,0,0-.719-.952c-.225-.1-.448-.2-.665-.309a.458.458,0,0,1-.291-.466.471.471,0,0,1,.328-.4.938.938,0,0,1,1.067.266c.118.138.158.44.4.266.189-.136,0-.355-.082-.521a1.265,1.265,0,0,0-.186-.225c.294-.228.767.018.841.5a.375.375,0,0,0,.36.363,1.928,1.928,0,0,0-.591,1.77C43.743,220.994,43.686,220.741,43.517,220.669Z",
    transform: "translate(-38.252 -185.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M354.031,178.842a25.739,25.739,0,0,0-.4-3.4,2.588,2.588,0,0,0-.673-1.585,2.7,2.7,0,0,1-.455-1.283c-.02-.1,0-.217.122-.238.141-.026.141.1.153.2a2.45,2.45,0,0,0,.778,1.545,1.071,1.071,0,0,1,.312.851,12.212,12.212,0,0,0,.314,2.376c.056-.639.115-1.271.158-1.9a4.445,4.445,0,0,0-.227-2.084c-.113-.268-.1-.519.322-.374-.033.622.309,1.2.22,1.833a6.048,6.048,0,0,0-.107,1.31,15.546,15.546,0,0,0-.177,1.972c0,.131-.012.263-.016.394-.107.128-.025.261-.012.392-.03.064-.061.126-.09.19l-.1.02Q354.085,178.946,354.031,178.842Z",
    transform: "translate(-297.891 -147.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.858,156.693c.036.1.074.2.11.3-.085.161-.059.365-.2.506-.218-.125-.353-.4-.68-.388a1.941,1.941,0,0,0,.388.672c-.011.059-.021.117-.033.176l-.5.215-.21-.008a1.167,1.167,0,0,0-.655-.171c-.11-.064-.222-.126-.33-.194-.077-.049-.2-.1-.143-.212.084-.163.192-.043.278.016a.933.933,0,0,0,.885.089,1.237,1.237,0,0,0-.563-.154c-.312.021-.24-.168-.232-.337.322-.1.438-.286.194-.568-.094-.107-.061-.2-.049-.305a2.56,2.56,0,0,1,.874-.358l.2.056.016.007a.456.456,0,0,1,.056.033.2.2,0,0,0,.218.117.32.32,0,0,1,.066.067Z",
    transform: "translate(-80.669 -133.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M153.377,222.593c.136-.23.284-.227.461-.038.133.14.312.236.393.424a2.238,2.238,0,0,0-.2,1.544l-.534-.028c.025-.108.1-.241-.033-.307-.171-.085-.263.054-.351.179-.217.3-.488.463-.823.2-.3-.236-.187-1.133.156-1.491a.553.553,0,0,1,.859-.013c.1.112.159.365.351.218s.028-.324-.084-.465C153.51,222.738,153.441,222.667,153.377,222.593Z",
    transform: "translate(-130.419 -189.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M115.009,225.65l-.511-.466a2.157,2.157,0,0,1,.149-1.444c.02-.03.041-.057.061-.087a1.282,1.282,0,0,1,1.642-.292.044.044,0,0,0,0,.053c.031.076.061.149.094.223.284.645.153.856-.529.851-.212,0-.424,0-.636,0s-.452,0-.432.315a.473.473,0,0,0,.48.511.8.8,0,0,0,.627-.328c.184-.207.345-.266.4.1a.734.734,0,0,0-.253.376A2.614,2.614,0,0,1,115.009,225.65Zm.567-1.393c.166-.179.6.182.608-.317.007-.315-.241-.448-.529-.45-.35,0-.645.187-.65.527S115.367,224.126,115.576,224.257Z",
    transform: "translate(-98.923 -189.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.743,226.872c0-.135-.026-.278.082-.389a.635.635,0,0,0,.663-.747c-.082-.58-.2-1.153-.307-1.729.044-.148-.148-.406.158-.427.232-.016.21.217.236.366.077.429.14.862.218,1.363a5.663,5.663,0,0,0,.723-1.189c.108-.164.2-.335.322-.491a.174.174,0,0,1,.225-.038.139.139,0,0,1,.038.212,26.423,26.423,0,0,1-1.785,3.046C69.124,226.855,68.934,226.863,68.743,226.872Z",
    transform: "translate(-60.738 -190.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M136.009,147.349q0-3.316,0-6.631a1.345,1.345,0,0,0-.182-.847l-.013-.033a.389.389,0,0,0,.034-.085c.2-.049.415-.266.581-.071a.642.642,0,0,1,.01.7,1.493,1.493,0,0,0-.13.711q0,2.522,0,5.045a1.484,1.484,0,0,0,.09.622C136.595,147.211,136.524,147.3,136.009,147.349Z",
    transform: "translate(-116.792 -119.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M247.9,205.1a.71.71,0,0,0,.654-.365c.125-.24.236-.19.342,0a2.814,2.814,0,0,0,1.031.948c.131.087.22.887.087.964-.2.117-.2-.082-.24-.19a1.919,1.919,0,0,0-.772-1.1c-.384-.243-.652-.084-.918.163a.591.591,0,0,0-.143.867,1.907,1.907,0,0,0,1.35.882c.42.049.442.084.286.384l-.3-.087c-.241-.145-.378,0-.5.179a1.4,1.4,0,0,0-.974-.655c.143-.608-.476-.69-.75-1.067a1.043,1.043,0,0,0,.659-.627.367.367,0,0,0,.19-.3Z",
    transform: "translate(-209.764 -174.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M163.466,225.1a2.238,2.238,0,0,1,.2-1.544c.1-.079.2-.169.31-.238a1.083,1.083,0,0,1,1.113-.1.931.931,0,0,1,.483.943,1.3,1.3,0,0,1-.984,1.394A.932.932,0,0,1,163.466,225.1Zm1.731-.972c0-.463-.2-.708-.567-.7a1.027,1.027,0,0,0-.857,1.136c0,.44.218.7.578.7C164.826,225.263,165.2,224.765,165.2,224.126Z",
    transform: "translate(-139.858 -189.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M54.774,225.085a1.928,1.928,0,0,1,.591-1.77c1.018-.315,1.45-.076,1.586.883,0,.1,0,.2-.008.3l-.143.47a2.469,2.469,0,0,1-.668.631,1.667,1.667,0,0,1-.764.031l-.284-.113C54.982,225.372,54.879,225.229,54.774,225.085Zm.371-.476c0,.488.2.759.565.757.429,0,.834-.563.847-1.159.008-.392-.126-.685-.558-.714C55.528,223.461,55.148,223.971,55.145,224.608Z",
    transform: "translate(-49.046 -189.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M262.454,167.55c.348.222.008.333-.1.415a11.5,11.5,0,0,0-1.268,1.214,1.427,1.427,0,0,0,.084,1.923c.048.3.281.4.524.442a3.635,3.635,0,0,0,1.55.1.45.45,0,0,1,.5.1c.151.192.084.394-.11.68.054-.532-.238-.537-.552-.532-.409.007-.816.008-1.225-.007a1.34,1.34,0,0,1-1.388-1.079c0-.164-.008-.327-.013-.491l.01-.2a2.3,2.3,0,0,1,1.1-1.964l.19-.113.2-.09a.76.76,0,0,0,.386-.3Z",
    transform: "translate(-220.972 -143.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M346.744,178.4c-.2-1.156-.673-2.243-.8-3.417-.041-.365-.409-.578-.6-.882s-.4-.594-.591-.9c-.069-.113-.1-.278.074-.328s.176.125.2.223a2,2,0,0,0,.77,1.1,1.137,1.137,0,0,1,.46.972,6.428,6.428,0,0,0,.4,1.795,4.187,4.187,0,0,0-.151-1.939c.266.01.317.174.33.335a12.925,12.925,0,0,1,.117,3.022c-.025.159.01.338-.2.4C346.749,178.658,346.747,178.528,346.744,178.4Z",
    transform: "translate(-291.375 -147.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M129.623,224.265l-.166-.383-.172-.34c.184-.248.335-.141.478.044.292.713.3.718.747.117a.684.684,0,0,1,.616-.307l-.113.35a.237.237,0,0,0-.163.192c-.179.069-.25.232-.335.383a.454.454,0,0,0-.1.65,2.337,2.337,0,0,1,.327.813.9.9,0,0,1-.445-.146c-.051-.22-.107-.458-.322-.558-.135-.062-.21.1-.261.222-.279.161-.374.594-.8.534l.015-.261a.419.419,0,0,0,.205-.289C129.442,225.016,129.926,224.829,129.623,224.265Z",
    transform: "translate(-111.025 -189.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M295.438,136.74c.25-.1.117-.273.062-.4a1.783,1.783,0,0,0-1.2-1.048c-.277-.087-.565-.145-.849-.215,0-.066-.01-.133-.013-.2,0-.1,0-.2,0-.3-.039-.516.186-.762.713-.7.1.273-.143.186-.25.228-.261.1-.258.322-.228.534.039.274.235.248.484.207a.39.39,0,0,1-.146-.521c.031-.076.225-.018.245.066.13.575.621.4.98.489l0,0,.2.1,0,0c.1.235-.415.337-.149.575.345.309.3.98.941,1l0,0c.09.386-.437.076-.44.4,0,.217.121.453-.051.659a.527.527,0,0,1-.5.232c.417-.327.2-.718.2-1.082A.145.145,0,0,1,295.438,136.74Z",
    transform: "translate(-248.53 -115.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M343.14,128.238c.02-.294-.246-.3-.412-.411s-.309-.259-.169-.481c.1-.164.207-.374.43-.1.085.105.177.021.243-.054.044-.051.077-.145.008-.168-.327-.108-.31-.289-.125-.509.248-.292.388.028.572.105a.992.992,0,0,0,.141.038c.189.013.409-.048.5.209-.025.952-.319,1.292-1.187,1.366Z",
    transform: "translate(-289.539 -108.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M151.376,223.473c.064.074.133.145.194.22.112.141.269.324.084.465s-.251-.107-.351-.218a.553.553,0,0,0-.859.013c-.343.358-.452,1.255-.156,1.491.335.268.606.107.823-.2.089-.125.181-.263.351-.179.133.066.059.2.033.307-.12.232-.371.32-.537.5l-.365.039-.465-.084a1.219,1.219,0,0,1-.379-1.187,1.867,1.867,0,0,1,.7-1.177C150.76,223.472,151.067,223.473,151.376,223.473Z",
    transform: "translate(-128.418 -190.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M268.849,155.5a.45.45,0,0,1,.22-.31c.1-.069.192-.163.1-.284s-.212-.079-.315-.021a1.335,1.335,0,0,1-.936.2c-.01-.126.251-.1.144-.258a.2.2,0,0,0-.305-.038,1.377,1.377,0,0,1-.59.227.39.39,0,0,0-.365.345.417.417,0,0,0,.261.5,2.541,2.541,0,0,1,.126-.468.332.332,0,0,1,.434-.217c-.45.37-.074.744-.056,1.122-.411.069-.66-.245-.974-.406a1.141,1.141,0,0,1,.287-1.072c.131-.021.31.038.345-.159.049-.278.259-.22.438-.237a2.879,2.879,0,0,0,1.238.163c.549-.056.823.194.724.621Z",
    transform: "translate(-226.085 -132.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.646,225.239c.3.563-.181.749-.488,1.02l-.68-.028c-.051-.363-.214-.3-.4-.1a.8.8,0,0,1-.627.328.475.475,0,0,1-.48-.511c-.02-.312.209-.317.432-.315s.424,0,.636,0c.682,0,.813-.207.529-.851-.033-.074-.062-.149-.094-.223.417-.031.558.177.489.565a.588.588,0,0,0,.007.379c.049.1.077.233.2.251.153.021.179-.113.2-.225A.319.319,0,0,1,119.646,225.239Z",
    transform: "translate(-101.048 -190.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M146.367,223.453a1.874,1.874,0,0,0-.7,1.177,1.22,1.22,0,0,0,.379,1.187,1.318,1.318,0,0,1-.925.381c-.215.033-.3-.158-.284-.365a9.766,9.766,0,0,0,.466-2.384c.2.182.391.281.652.074C146.05,223.447,146.227,223.475,146.367,223.453Z",
    transform: "translate(-124.333 -190.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.226,144.456a1.252,1.252,0,0,1,.315,1.371c-.205.535-.351.581-.8.243-.324-.246-.647-.491-.982-.719-.181-.123-.171-.223-.067-.4.368-.634.928-.622,1.534-.493Zm-.7.256a.347.347,0,0,0-.409.189c-.062.163.1.217.2.294.207.159.412.324.626.475.1.074.227.182.346.049a.305.305,0,0,0,.057-.368C239.145,145.052,238.94,144.745,238.524,144.712Z",
    transform: "translate(-201.882 -123.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M294,112.522l.2.018.388.115h0c.039.062.079.125.117.187a1.366,1.366,0,0,1-.227,1.67c-.289,0-.58.007-.869.011a8.486,8.486,0,0,0-.215-1.665c-.1-.289.169-.3.312-.4Zm-.084.842a1.351,1.351,0,0,0,0,.3c.057.2-.03.562.238.553.287-.008.348-.338.34-.616,0-.049,0-.1,0-.146-.005-.282-.08-.576-.4-.558C293.79,112.918,293.957,113.238,293.916,113.365Z",
    transform: "translate(-248.483 -97.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M264.84,216.966a3.563,3.563,0,0,1,.571-2.036c.1-.12.143-.213.294-.128.122.069.332.054.347.23.015.192-.179.143-.3.168-.445.092-.463.478-.509.8a.576.576,0,0,0,.447.631,2.5,2.5,0,0,0,1.729.12c.126-.051.319-.138.361.079.03.148-.143.192-.274.225a8.543,8.543,0,0,0-1.3.222c-.123.053-.146-.077-.212-.146a.8.8,0,0,0-1.064-.163Z",
    transform: "translate(-224.633 -182.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M251.68,180.247a1.369,1.369,0,0,0,.327-1.287c.25.21.292.291.235.56a4.642,4.642,0,0,1-.189.608.9.9,0,0,0,.33,1.232,1.99,1.99,0,0,1,1.049,1.489.735.735,0,0,0,.847.647c.228-.007.478-.028.535.291a.862.862,0,0,0-.09.015c-1.215-.028-1.365-.145-1.66-1.325a.808.808,0,0,0-.338-.571,4.374,4.374,0,0,1-1.043-.875C251.682,180.77,251.682,180.509,251.68,180.247Z",
    transform: "translate(-213.634 -152.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M246.349,137.238a3.055,3.055,0,0,0-.09-.325.817.817,0,0,1,.128-1.028,1.033,1.033,0,0,1,1.143.09,1.129,1.129,0,0,1,.365,1.258.771.771,0,0,1-1.11.217c-.143-.074-.291-.143-.435-.215C246.346,137.237,246.349,137.238,246.349,137.238ZM247.69,137c.02-.3-.544-.9-.885-.972-.312-.064-.475.1-.371.4a1.264,1.264,0,0,0,.87.782A.268.268,0,0,0,247.69,137Z",
    transform: "translate(-209.002 -116.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M235.164,155.777c-.062.168-.084.409-.381.268-.172-.08-.356-.151-.471.057s.069.284.207.374.174.225.071.333c-.14.144-.235-.026-.315-.108a8.056,8.056,0,0,0-1.01-.926.343.343,0,0,1-.161-.424c.085-.2.253-.174.419-.115a5.7,5.7,0,0,0,1.429.328C235.074,155.574,235.182,155.6,235.164,155.777Z",
    transform: "translate(-198.085 -132.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M369.887,154.2c-.414.19-.828.383-1.243.572-.148.066-.317.171-.447,0-.149-.2.038-.324.148-.46.307-.378.764-.624.957-1.1C369.91,153.476,370.031,153.681,369.887,154.2Z",
    transform: "translate(-310.97 -131.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M371.61,170.856c-.036-.039-.072-.079-.11-.117a1.4,1.4,0,0,1,1.586-.78c.314.236.6.494.419.941a.931.931,0,0,1-.861.622c-.424.016-.885.08-1.033-.494a2.559,2.559,0,0,0,1.156.094c.278-.033.514-.194.491-.5s-.31-.263-.532-.279A1.654,1.654,0,0,0,371.61,170.856Z",
    transform: "translate(-313.777 -145.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M346.38,130.646c.869-.076,1.163-.414,1.187-1.366.57.038.5.365.274.783.324-.033.716-.411.8.189-.765,0-.908.128-1.117.888-.033.122.105.407-.192.343-.276-.059-.289-.273-.161-.5a.922.922,0,0,0,.049-.194C346.915,130.814,346.528,131.231,346.38,130.646Z",
    transform: "translate(-292.782 -111.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M305.081,112.38a1.038,1.038,0,0,1,.567,1.622c-.09.151-.187.3-.281.447a1.2,1.2,0,0,1-.685-.092,1.368,1.368,0,0,1-.08-1.866A.981.981,0,0,1,305.081,112.38Zm.392.989c0-.369-.171-.742-.365-.723-.378.039-.374.4-.473.655a.292.292,0,0,0-.007.191c.092.236,0,.644.392.627.351-.015.425-.346.452-.654C305.475,113.434,305.473,113.4,305.473,113.369Z",
    transform: "translate(-257.59 -97.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M276.21,115.649l.3,0a2.949,2.949,0,0,0,1.058.778c-.122-.325-.1-.611-.361-.775a.345.345,0,0,1,.09-.307c.156.021.269.084.291.263a8.853,8.853,0,0,0,.42,1.429c-.263.309-.406-.084-.612-.105-.174-.1-.287-.383-.514-.289-.151.062-.028.261.03.392.066.1.131.2.2.294-.038.1-.076.192-.112.289a.373.373,0,0,1-.292-.092c.125-.19.038-.381-.02-.558C276.535,116.519,276.368,116.086,276.21,115.649Z",
    transform: "translate(-234.136 -99.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M225.331,182.21c0-.064,0-.126,0-.19l.3.077c0,.131,0,.263-.01.392-.033.276.008.613-.136.81-.2.279-.463-.115-.726-.094-.292.023-.588,0-.883-.007-.163,0-.392.128-.4-.179a.982.982,0,0,1,.227-.862.108.108,0,0,1,.163.136c-.11.243-.105.409.187.48.264.062.36-.046.338-.309-.007-.089.08-.138.174-.128a.13.13,0,0,1,.125.126c.034.573.373.327.65.243A.407.407,0,0,0,225.331,182.21Z",
    transform: "translate(-190.049 -155.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M254.916,130.359a.382.382,0,0,0,.432-.154.2.2,0,0,0-.03-.268c-.151-.172-.317-.1-.494-.039a.584.584,0,0,1-.819-.307.594.594,0,0,1,.325-.78c.135-.08.287-.148.371.043.076.172-.066.222-.207.248s-.3.044-.25.223c.034.14.19.164.327.161a1.057,1.057,0,0,0,.145-.023c.573-.087.844.049.91.452a.817.817,0,0,1-.682.883.211.211,0,0,1-.256-.08c-.062-.1-.143-.2-.08-.315C254.684,130.262,254.809,130.341,254.916,130.359Z",
    transform: "translate(-215.533 -110.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M373.447,181.23a.642.642,0,0,1,.046-.236.273.273,0,0,1,.414-.125c.177.12.013.218-.079.3-.126.12-.225.248-.113.427a.287.287,0,0,0,.284.161c.215-.03.3-.189.314-.383a.556.556,0,0,1,.714-.545c.443.067.386.473.432.783a.2.2,0,0,1-.258.222c-.153-.025-.159-.145-.094-.264.085-.158.149-.337-.067-.407-.251-.082-.3.131-.324.317-.059.389-.228.657-.673.6S373.436,181.746,373.447,181.23Z",
    transform: "translate(-315.404 -154.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M260.871,152.282a1.141,1.141,0,0,0-.287,1.072c-.135.015-.266.115-.406.015.053-.13.094-.284-.1-.291a.626.626,0,0,1-.673-.667c-.018-.366-.08-.757.286-1.021-.08.89-.08.89.785.588A.823.823,0,0,0,260.871,152.282Z",
    transform: "translate(-220.074 -129.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M257.382,147.93c-.365.264-.3.655-.286,1.021a.626.626,0,0,0,.673.667c.2.008.156.163.1.291-.92-.011-1.048-.2-1.209-1.105a1.382,1.382,0,0,1,.624-1.553c.563.143-.174.25-.01.381-.021.018-.092-.02-.062.056l.067-.049a.351.351,0,0,1,.1.3Z",
    transform: "translate(-217.769 -126.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M226.619,172.774c-.759.013-1.082-.414-.78-1.023.064-.128.133-.246.292-.158s.186.212.025.346c-.112.092-.258.205-.108.361s.291.053.376-.072c.266-.384.611-.6,1.038-.333s.215.7.122,1.069a.651.651,0,0,1-.066.131c-.1,0-.2-.007-.3-.008l-.212-.108a2.8,2.8,0,0,0,.307-.149.438.438,0,0,0,.182-.473.258.258,0,0,0-.222-.23c-.2-.034-.3.089-.391.235S226.706,172.636,226.619,172.774Z",
    transform: "translate(-191.942 -146.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M254.761,178.4a1.39,1.39,0,0,1,.9,1.181c.03.319.355.442.558.732-.6,0-.746-.406-.81-.783a1.226,1.226,0,0,0-.757-.941.8.8,0,0,1-.443-1.021,3.308,3.308,0,0,1,.117-.374c.194-.5.166-.928-.381-1.192a.321.321,0,0,1-.094-.108c-.008-.01,0-.031,0-.077.25-.062.389.2.606.22.034.066.071.13.105.2l.1.2a4.269,4.269,0,0,1-.194,1.084c-.159.256-.021.475.09.7Z",
    transform: "translate(-215.446 -150.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M229.658,162.38c-.046-.033-.11-.077-.174-.125a4.815,4.815,0,0,0-1.127-.463c-.176-.074-.281-.007-.315.182-.018.1-.034.215-.176.156a.163.163,0,0,1-.077-.212q.2-.549.425-1.094c.038-.092.122-.171.232-.1.094.057.039.145,0,.213-.2.3,0,.407.238.5.35.133.7.269,1.051.4.184.067.189.2.156.358A.228.228,0,0,1,229.658,162.38Z",
    transform: "translate(-193.656 -137.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M314.029,116.049c0-.082-.011-.164-.01-.245,0-.1-.01-.213.089-.264.159-.082.177.087.246.163.149.164.33.338.537.148s.076-.392-.115-.53c-.271-.194-.583-.379-.415-.78.177-.425.57-.366.931-.343.156.2.1.361-.1.493-.044-.2-.153-.325-.378-.274a.177.177,0,0,0-.149.215c.044.23.232.243.415.256a2.078,2.078,0,0,1,.2.437c.12.567-.072.792-.677.833l-.2-.09C314.282,116.06,314.155,116.055,314.029,116.049Z",
    transform: "translate(-265.735 -98.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M91.169,158.907c-.008.169-.08.356.232.337a1.2,1.2,0,0,1,.563.154.933.933,0,0,1-.885-.089c-.085-.059-.194-.179-.278-.016-.059.113.066.163.143.212.107.069.22.13.33.194-.122.189-.243.378-.365.565-.223.015-.14-.2-.227-.294-.039-.356-.356-.655-.218-1.049-.038-.429.253-.663.529-.91,0,.25.172.475.092.734,0,.071,0,.146.1.158Z",
    transform: "translate(-78.864 -135.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M323.148,256.382c-.108.122-.7.237.135.356-.659.2-1.187.35-1.71.522-.225.074-.489.118-.58.4l0,0a1.8,1.8,0,0,1-.749-.077c.212-.159.463-.187.56-.4a1.876,1.876,0,0,0,.583-.4,2.51,2.51,0,0,0,.89-.289l.192-.023.2-.082Zm-.594.35c0-.011,0-.03-.007-.033s-.026,0-.039,0c0,.016.007.034.011.051Z",
    transform: "translate(-270.943 -217.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M360.74,142.833c.03.125.105.251.02.376-.054.079-.12.176-.233.135s-.069-.131-.049-.21c.041-.164.076-.335-.1-.437a.506.506,0,0,0-.557.059,2.756,2.756,0,0,0-.473.422c-.3.335-.241.517.2.642.1.03.269,0,.223.176-.036.138-.184.118-.294.092a.578.578,0,0,1-.5-.42,1.01,1.01,0,0,1,.2-.925,1.3,1.3,0,0,1,.867-.412C360.369,142.358,360.682,142.414,360.74,142.833Z",
    transform: "translate(-303.28 -122.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M339.228,121.244q-.32.589-.642,1.176c-.079.143-.164.32-.363.245-.222-.085-.179-.287-.115-.46.169-.453.348-.9.522-1.355C338.914,120.852,339.2,120.852,339.228,121.244Z",
    transform: "translate(-285.826 -104.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M68.1,227.061c0-.1,0-.2.008-.3.348.007.251-.453.537-.512.105.576.227,1.15.307,1.729a.635.635,0,0,1-.663.747c.241-.432.015-.923.176-1.374C68.579,227.03,68.169,227.229,68.1,227.061Z",
    transform: "translate(-60.201 -192.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M137.945,230.319a2.307,2.307,0,0,0-.327-.813.453.453,0,0,1,.1-.65c.228.524.315.54.69.117a.42.42,0,0,1,.286-.153c-.087.484-.172.971-.259,1.455-.015.158-.062.292-.255.294C138.017,230.569,137.954,230.467,137.945,230.319Z",
    transform: "translate(-118.227 -194.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M271.688,116.727c.158.437.325.872.468,1.314a.609.609,0,0,1,.02.558c-.217.015-.049-.5-.406-.294a2.521,2.521,0,0,1-.479-1.013c-.038-.241-.192-.278-.391-.264-.033-.133-.066-.264-.1-.4h0C271.094,116.691,271.37,116.906,271.688,116.727Z",
    transform: "translate(-229.614 -100.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M372.17,172.861a1.645,1.645,0,0,1,1.117-.516c.222.018.509-.038.532.279s-.214.47-.491.5a2.557,2.557,0,0,1-1.156-.094C372.17,172.977,372.17,172.918,372.17,172.861Z",
    transform: "translate(-314.337 -147.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M111,224.363a2.158,2.158,0,0,0-.149,1.444c-.32-.056-.5.268-.785.3a18.489,18.489,0,0,1,.473-2.173C110.7,224.076,110.85,224.219,111,224.363Z",
    transform: "translate(-95.279 -190.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M143.06,225.7c.087-.484.172-.971.259-1.455.057-.289.113-.576.171-.865l.253-.033a.108.108,0,0,0,.074.016,9.765,9.765,0,0,1-.466,2.384Z",
    transform: "translate(-122.851 -189.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M266.8,123.167a.655.655,0,0,1-.66-.406c-.136-.258-.266-.519-.4-.775-.089-.169-.353-.333-.066-.526.271-.181.407.03.522.24.113.847.33,1.131.9,1.173-.033.067-.066.133-.1.2Z",
    transform: "translate(-225.223 -104.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M296.383,132.077c-.36-.094-.851.085-.98-.489-.02-.085-.213-.141-.245-.066a.393.393,0,0,0,.146.521c-.25.041-.445.069-.484-.207-.03-.212-.034-.43.228-.534.105-.041.348.046.25-.228.076-.317.059-.749.6-.465-.494.6-.41.989.284,1.276A.322.322,0,0,1,296.383,132.077Z",
    transform: "translate(-249.678 -112.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M261.836,146.478c-.865.3-.865.3-.785-.588l0,0c.222-.071.248-.286.314-.458.077-.2-.015-.457.186-.626.276,0,.307.179.292.392a.272.272,0,0,0-.225.327.788.788,0,0,1-.269.657c-.08.115-.03.166.09.181a.485.485,0,0,0,.3-.176.38.38,0,0,0,.3-.2v0C262.435,146.352,261.856,146.3,261.836,146.478Z",
    transform: "translate(-221.438 -124.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M355.483,136.752a9.276,9.276,0,0,0-1.171,1.1c-.151.151-.251.189-.4.038s-.09-.263.084-.378a5.846,5.846,0,0,0,1.168-1.163C355.272,136.485,355.378,136.618,355.483,136.752Z",
    transform: "translate(-299.005 -117.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M283.521,116.237a8.532,8.532,0,0,1-.42-1.429c-.021-.179-.135-.241-.291-.263.176-.333.342-.028.512.008a1.95,1.95,0,0,1,.47,1.68Z",
    transform: "translate(-239.652 -98.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M286.39,115.973a1.95,1.95,0,0,0-.47-1.68c.051-.2.225-.182.373-.213a.368.368,0,0,1,.253.333,8.185,8.185,0,0,1,.328,1.65C286.707,116.064,286.533,116.1,286.39,115.973Z",
    transform: "translate(-242.251 -98.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M270.422,123.391c-.57-.041-.788-.325-.9-1.173.138-.069.276-.138.414-.209a1.809,1.809,0,0,1,.488,1.381Z",
    transform: "translate(-228.544 -105.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M301.113,113.055a1.368,1.368,0,0,0,.081,1.866,1.59,1.59,0,0,0-1.094.089,1.366,1.366,0,0,0,.227-1.67C300.64,113.389,300.809,113.034,301.113,113.055Z",
    transform: "translate(-254.102 -97.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M246.225,200.843a.546.546,0,0,0,.092-.03c.256-.135.511-.457.8-.145a.793.793,0,0,1,.077,1.059l0,0-.3.02C246.463,201.6,246.159,201.362,246.225,200.843Zm.925.333c-.036-.171-.087-.348-.3-.379-.135-.02-.209.074-.218.2a.339.339,0,0,0,.3.371C247.077,201.4,247.144,201.322,247.149,201.176Z",
    transform: "translate(-209.067 -170.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M243.978,173.167c-.156-.189-.066-.435-.123-.644-.11,0-.12.069-.128.133-.018.138.113.294-.03.411-.071.057-.156-.007-.207-.072-.12-.156-.255-.328-.148-.527.092-.168.286-.381.44-.328.205.071.565-.059.608.327C244.085,172.6,244.3,173.04,243.978,173.167Z",
    transform: "translate(-206.633 -147.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M335.577,117.38c-.565-.08-.652.532-1.141.772a5.239,5.239,0,0,0-.036-1.273c.1-.19.287-.268.343-.046.1.393.3.45.634.371C335.484,117.178,335.545,117.28,335.577,117.38Z",
    transform: "translate(-282.77 -100.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M336.511,239.093c-.215-.151-.422-.355-.186-.59a.856.856,0,0,1,1.072-.051c-.3.217-.64-.108-.895.23a1.391,1.391,0,0,1,.9.117l-.108.19-.489.112C336.708,239.1,336.609,239.094,336.511,239.093Z",
    transform: "translate(-284.291 -202.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.32,225.648a7.343,7.343,0,0,1,.486-2.028c.072.48.143.957.215,1.437-.191,0-.35.033-.4.256A.387.387,0,0,1,94.32,225.648Z",
    transform: "translate(-82.115 -190.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M103.83,226.635a8.891,8.891,0,0,1,.966-1.575,7.473,7.473,0,0,1-.323,1.7C104.331,226.346,104.035,226.725,103.83,226.635Z",
    transform: "translate(-90.064 -191.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M372.125,168a1.4,1.4,0,0,0-1.586.78c-.3-.171-.145-.46-.179-.7a2.092,2.092,0,0,0,1.023-.287,1.391,1.391,0,0,1,.747-.191C372.128,167.74,372.127,167.871,372.125,168Z",
    transform: "translate(-312.816 -143.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M259.1,230.638a.634.634,0,0,1,.286.685.932.932,0,0,1-1.174-.394,3.26,3.26,0,0,1,.952.118c-.322-.384-.654-.284-.943-.323C258.476,230.337,258.8,230.671,259.1,230.638Z",
    transform: "translate(-219.091 -195.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M117.728,220.733a1.284,1.284,0,0,0-1.642.292c-.03-.721-.03-.721.795-.744.232.036.366-.146.539-.241C117.541,220.265,117.786,220.431,117.728,220.733Z",
    transform: "translate(-100.3 -187.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M135.473,221.773a.684.684,0,0,0-.616.307c-.45.6-.457.594-.747-.117a.567.567,0,0,0,.594-.314C134.9,221.331,135.3,221.413,135.473,221.773Z",
    transform: "translate(-115.371 -188.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M347.965,223.009c-.238-.015-.521.046-.621-.256-.062-.19.084-.335.212-.461a.694.694,0,0,1,.727-.141c.227.067.156.289.171.46C348.3,222.758,348.2,222.97,347.965,223.009Zm.218-.524a.132.132,0,0,0-.138-.158.379.379,0,0,0-.427.256c-.039.11.025.194.146.2A.448.448,0,0,0,348.183,222.485Z",
    transform: "translate(-293.576 -188.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M177.093,64.24a2.316,2.316,0,0,1-.008,1.836A2.029,2.029,0,0,1,177.093,64.24Z",
    transform: "translate(-151.109 -56.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M318.587,260.433c-.1.218-.348.245-.56.4a1.8,1.8,0,0,0,.749.077c-.427.351-.808.143-1.186-.1C317.674,260.272,318.035,260.134,318.587,260.433Z",
    transform: "translate(-268.72 -220.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M139.44,96.328a2.666,2.666,0,0,0,1.448-.228c.191.2.049.361-.085.5C140.56,96.849,139.624,96.657,139.44,96.328Z",
    transform: "translate(-119.826 -83.603)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M321.45,131.372a7.7,7.7,0,0,1-1.48-.489c.493-.4.806-.366,1.164.126C321.23,131.141,321.418,131.189,321.45,131.372Z",
    transform: "translate(-270.709 -112.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M273.23,243.355c.064-.209.238-.2.4-.2a2.565,2.565,0,0,1,1.225.324c.168.09.314.205.3.411s-.164.309-.358.348l0,0c.235-.588-.207-.665-.593-.785Z",
    transform: "translate(-231.645 -206.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M93.34,168.855c.122-.189.243-.378.365-.565a1.177,1.177,0,0,1,.655.171l-.639.072a1.5,1.5,0,0,1,.67.571A1.2,1.2,0,0,1,93.34,168.855Z",
    transform: "translate(-81.296 -143.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M271.74,120.9a1.826,1.826,0,0,0-.488-1.381c-.036-.163-.251-.287-.1-.488.2-.013.353.023.391.264a2.5,2.5,0,0,0,.48,1.013C272.023,120.547,272.039,120.8,271.74,120.9Z",
    transform: "translate(-229.863 -102.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M103.946,162.706c.136-.141.11-.345.2-.506a.41.41,0,0,1,.212.34.945.945,0,0,1-.21.522c-.076.125-.161.258.036.358.021.025.043.049.066.074-.09.156-.186.3-.4.286-.163-.172-.386-.322-.223-.613.011-.059.021-.117.033-.176C103.814,162.96,103.877,162.829,103.946,162.706Z",
    transform: "translate(-89.843 -138.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M231.16,175.6c.087-.138.176-.276.261-.415s.2-.268.391-.235a.258.258,0,0,1,.222.23.438.438,0,0,1-.182.473,2.407,2.407,0,0,1-.307.149Z",
    transform: "translate(-196.484 -149.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.964,236.67l-.015.261c-.322.076-.736-.13-.936.312h0a1.822,1.822,0,0,1-.877-.079c-.347-.135.016-.166.01-.245a2.639,2.639,0,0,0,1.09-.192C118.479,236.709,118.721,236.69,118.964,236.67Z",
    transform: "translate(-101.059 -201.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M278.706,116.52c.266.164.24.45.361.775a2.948,2.948,0,0,1-1.058-.778c.053-.154.151-.169.248-.057C278.4,116.622,278.552,116.545,278.706,116.52Z",
    transform: "translate(-235.64 -100.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M263.4,148.2a.481.481,0,0,1-.3.176c-.03-.061-.061-.122-.09-.181a.788.788,0,0,0,.269-.657.271.271,0,0,1,.225-.327c.343.2.136.529.2.793v0A.267.267,0,0,0,263.4,148.2Z",
    transform: "translate(-223.103 -126.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.315,140.968a.646.646,0,0,0-.1.4l0,0c-.034.067-.067.135-.1.2l0,0-.2.1,0,0-.1.1,0,0-.1.1,0,0c-.187-.021-.383-.085-.125-.264a1.123,1.123,0,0,0,.419-1.11c.135-.08.21.021.294.1,0,.033,0,.066.007.1C280.32,140.772,280.318,140.869,280.315,140.968Z",
    transform: "translate(-236.864 -120.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M96.33,169.974a1.5,1.5,0,0,0-.67-.571l.639-.072.21.008c.043.062.135.158.12.181-.228.332.054.282.227.317A.524.524,0,0,1,96.33,169.974Z",
    transform: "translate(-83.235 -144.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M363.88,197.142a15.582,15.582,0,0,1,.177-1.972A2.3,2.3,0,0,1,363.88,197.142Z",
    transform: "translate(-307.409 -166.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M260.972,144.56c-.2.169-.108.424-.186.626-.066.172-.09.388-.314.458a.351.351,0,0,0-.1-.3l0-.007c-.164-.131.573-.24.01-.381C260.157,144.207,260.742,144.644,260.972,144.56Z",
    transform: "translate(-220.865 -124.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M155.51,101.1c-.238.046-.259-.264-.46-.281a.354.354,0,0,1,.448-.274.479.479,0,0,1,.435.457C155.842,101.245,155.63,100.972,155.51,101.1Z",
    transform: "translate(-132.872 -87.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M286.419,140.156c-.08.094-.089.246-.273.3,0-.4-.172-.437-.447-.194,0-.1,0-.2.008-.3.038-.064.074-.13.112-.194C286.152,139.465,286.285,139.552,286.419,140.156Z",
    transform: "translate(-242.067 -119.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M361.617,234.1c.007.209.209.567-.3.384a.955.955,0,0,0-.1-.22c-.131-.164-.266-.36-.018-.488C361.493,233.627,361.549,233.9,361.617,234.1Z",
    transform: "translate(-305.056 -198.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M266.42,235.957a1.315,1.315,0,0,1,1.069.488c.094.1.156.236,0,.333s-.21-.021-.243-.143a.374.374,0,0,0-.3-.291C266.8,236.172,266.519,236.19,266.42,235.957Z",
    transform: "translate(-225.953 -200.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.755,136.158a2.836,2.836,0,0,1-.985-.591C331.447,135.409,331.706,135.565,331.755,136.158Z",
    transform: "translate(-279.736 -116.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M500.731,85.614c.287.153.319.182.209.3-.089.09.062.266-.112.269-.246,0-.251-.271-.4-.389l0-.066c0-.039,0-.079,0-.117-.062-.1-.253-.22-.061-.3S500.66,85.45,500.731,85.614Z",
    transform: "translate(-421.418 -74.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M48.84,107.65c.263.059.491.241.785.2.087-.013.094.11.1.189C49.231,108.379,48.917,108.243,48.84,107.65Z",
    transform: "translate(-44.104 -93.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M346.46,259.98l.665.1c.1.189.153.379-.113.461a.346.346,0,0,1-.5-.233C346.488,260.2,346.48,260.09,346.46,259.98Z",
    transform: "translate(-292.849 -220.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M357.284,216.576a.634.634,0,0,1,.682-.384c0,.1.01.192.015.289-.107.2-.365.213-.5.386l-.294-.092,0,0C357.221,216.709,357.252,216.642,357.284,216.576Z",
    transform: "translate(-301.817 -183.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M243.038,192.436c0,.033.016.071,0,.1-.09.189.3.455.021.519-.24.056-.5-.2-.522-.522A.331.331,0,0,1,243.038,192.436Z",
    transform: "translate(-205.995 -164.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M314.59,254.917c.323-.145.6-.407.987-.384-.117.253-.371.384-.535.608C314.84,255.416,314.7,255.1,314.59,254.917Z",
    transform: "translate(-266.213 -216.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.16,234.681a2.469,2.469,0,0,0,.668-.631c.255.32.11.548-.187.713C63.477,234.851,63.257,235.065,63.16,234.681Z",
    transform: "translate(-56.072 -198.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M516.76,104.572c.077-.191.378-.342.1-.593.166-.039.314-.209.5-.066,0,.054,0,.108-.007.163-.153.12-.021.251-.016.378-.031.048-.062.094-.092.141A.449.449,0,0,1,516.76,104.572Z",
    transform: "translate(-435.183 -90.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M279.2,244.98c.386.12.828.2.593.785l-.4-.107Z",
    transform: "translate(-236.635 -208.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M91.45,97.406c.555,0,1.112-.01,1.667-.016a2.014,2.014,0,0,1-1.4.2C91.6,97.556,91.5,97.528,91.45,97.406Z",
    transform: "translate(-79.717 -84.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M269.6,266.128c.256.013.5-.149.772-.079,0,.218-.228.345-.172.557C269.894,266.579,269.648,266.476,269.6,266.128Z",
    transform: "translate(-228.611 -225.628)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M328.09,256.007a2.509,2.509,0,0,1-.89.289C327.244,255.735,327.39,255.688,328.09,256.007Z",
    transform: "translate(-276.752 -217.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M101.186,168.773c-.172-.033-.457.015-.227-.317.015-.021-.077-.118-.12-.181l.5-.215c-.163.291.061.44.223.613A.557.557,0,0,1,101.186,168.773Z",
    transform: "translate(-87.565 -143.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M330.164,125.018a.833.833,0,0,1,.394-.818v.921A.539.539,0,0,1,330.164,125.018Z",
    transform: "translate(-279.228 -107.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M375.891,163.092c-.108.361-.434.324-.811.46.208-.32.355-.54.5-.762C375.755,162.816,375.791,162.989,375.891,163.092Z",
    transform: "translate(-316.769 -139.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M272.075,149.59c-.034.186-.4.34-.021.578.074.046-.176.084-.277.122-.2-.049-.32-.161-.264-.373C271.589,149.629,271.824,149.59,272.075,149.59Z",
    transform: "translate(-230.198 -128.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M93.942,158.395c.08-.258-.1-.484-.092-.734.026-.023.053-.048.077-.071l.207.057c.011.012.025.023.036.036-.011.107-.043.2.049.305.245.282.126.466-.194.568l.013,0C94.06,158.467,94,158.429,93.942,158.395Z",
    transform: "translate(-81.722 -134.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M313.777,130.138a2.639,2.639,0,0,1-.987-.191C313.228,129.6,313.532,129.663,313.777,130.138Z",
    transform: "translate(-264.708 -111.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M106.684,164.654c-.2-.1-.112-.233-.036-.358a.941.941,0,0,0,.21-.522l.123-.094-.02.493c-.01.084-.021.166-.031.25l-.015.023a.238.238,0,0,1,.021.015l-.1.049A.19.19,0,0,0,106.684,164.654Z",
    transform: "translate(-92.347 -140.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M89.78,163.55c-.138.394.179.693.218,1.049C89.609,164.4,89.476,163.765,89.78,163.55Z",
    transform: "translate(-78.181 -139.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M121.519,218.4c-.172.1-.307.278-.539.241.135-.286.246-.6.7-.562C121.614,218.211,121.566,218.308,121.519,218.4Z",
    transform: "translate(-104.397 -185.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M537.843,95.551c-.071.179-.049.435-.335.438-.305,0-.156-.3-.268-.425C537.434,95.234,537.639,95.444,537.843,95.551Z",
    transform: "translate(-452.3 -83.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M275.486,144.865c-.03.327.054.736-.5.69,0-.1,0-.189.008-.284a.281.281,0,0,0,.187-.307c0-.064,0-.128.007-.192l.2-.011Z",
    transform: "translate(-233.116 -124.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M93.645,81.507l-1.555-.016c.388-.159.826-.059,1.217-.261C93.483,81.138,93.65,81.269,93.645,81.507Z",
    transform: "translate(-80.251 -71.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M232.47,109.145c.02-.168-.033-.435.145-.461.284-.041.287.324.46.468A.486.486,0,0,1,232.47,109.145Z",
    transform: "translate(-197.578 -94.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M96.5,155.472a2.592,2.592,0,0,0-.874.358c-.011-.011-.025-.023-.036-.036.033-.08.066-.161.1-.241C95.948,155.42,96.207,155.277,96.5,155.472Z",
    transform: "translate(-83.177 -133.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M249.7,174.17c-.1.3-.205.593-.309.89l-.187-.105a1.219,1.219,0,0,1,.182-.783C249.49,174.17,249.595,174.17,249.7,174.17Z",
    transform: "translate(-211.553 -148.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M45.04,82.732l-.608.583C44.347,82.714,44.489,82.578,45.04,82.732Z",
    transform: "translate(-40.401 -72.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M318.365,116.03c-.182-.013-.371-.026-.415-.256a.177.177,0,0,1,.149-.215c.225-.053.333.071.378.274C318.439,115.9,318.4,115.962,318.365,116.03Z",
    transform: "translate(-269.017 -99.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M279.364,141.18c.4.312.071.545-.107.767-.044.054-.074-.1-.1-.172C279.2,141.566,279.08,141.3,279.364,141.18Z",
    transform: "translate(-236.601 -121.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.036,216.663c-.259,0-.388.2-.537.363-.181-.153-.223-.33-.01-.47C108.683,216.427,108.907,216.356,109.036,216.663Z",
    transform: "translate(-93.838 -184.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M279.941,123.527c-.057-.133-.181-.33-.03-.392.227-.094.34.189.514.289C280.317,123.708,280.1,123.486,279.941,123.527Z",
    transform: "translate(-237.169 -106.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.567,109.34l.246.269c-.025.1,0,.289-.153.243a.593.593,0,0,1-.355-.3C331.247,109.386,331.447,109.376,331.567,109.34Z",
    transform: "translate(-280.175 -94.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147.35,84.441a.74.74,0,0,0-.2-.732c.163-.028.379-.074.419.117C147.615,84.043,147.657,84.321,147.35,84.441Z",
    transform: "translate(-126.27 -73.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M133.82,233.812c.053-.12.128-.284.261-.222.215.1.269.338.322.558C134.122,234.186,133.969,234,133.82,233.812Z",
    transform: "translate(-115.129 -198.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.421,87.32l-.384.392c-.266-.02-.34-.136-.133-.33a.8.8,0,0,1,.506-.163C41.412,87.253,41.416,87.287,41.421,87.32Z",
    transform: "translate(-37.371 -76.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M153.344,89.407a1.011,1.011,0,0,1-.007-.838A.934.934,0,0,1,153.344,89.407Z",
    transform: "translate(-131.369 -77.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M146.486,217.682l.11-.041c.064,0,.128-.007.192-.012.181.271.182.48-.192.562-.034,0-.067-.008-.1-.012l-.025-.292C146.475,217.819,146.481,217.751,146.486,217.682Z",
    transform: "translate(-125.701 -185.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M149.05,92.518c.007-.159.013-.319.021-.478a.444.444,0,0,1,.094.03c.138.08.355.143.31.327C149.426,92.6,149.2,92.511,149.05,92.518Z",
    transform: "translate(-127.858 -80.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M258.21,231.68c.289.039.621-.061.943.323a3.261,3.261,0,0,0-.952-.118Z",
    transform: "translate(-219.083 -196.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M366.45,222.17l-.389.691C366.024,222.538,365.936,222.185,366.45,222.17Z",
    transform: "translate(-309.206 -188.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M351.359,229.172c-.209-.059-.182-.236-.2-.392l.509.08C351.646,229.053,351.508,229.118,351.359,229.172Z",
    transform: "translate(-296.777 -194.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M68.477,243.575l.573-.025a.361.361,0,0,1-.461.3C68.435,243.826,68.369,243.726,68.477,243.575Z",
    transform: "translate(-60.472 -206.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M299.92,108.82l-.03.427c-.2.026-.312-.14-.511-.207C299.544,108.866,299.746,108.874,299.92,108.82Z",
    transform: "translate(-253.501 -94.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M292.358,260.932c-.273.163-.435-.016-.6-.194C292.018,260.623,292.259,260.56,292.358,260.932Z",
    transform: "translate(-247.132 -221.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M257.55,222.685c.125-.179.261-.325.5-.179C257.962,222.783,257.844,222.979,257.55,222.685Z",
    transform: "translate(-218.54 -189.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.72,126.726c.064-.248.271-.388.457-.716a.918.918,0,0,1-.266.726C333.846,126.731,333.784,126.729,333.72,126.726Z",
    transform: "translate(-282.201 -108.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M327.626,123.86c-.038.263-.1.511-.406.591A.574.574,0,0,1,327.626,123.86Z",
    transform: "translate(-276.769 -106.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M259.99,258.248c.138,0,.33-.067.348.135s-.182.222-.343.237C259.992,258.494,259.992,258.371,259.99,258.248Z",
    transform: "translate(-220.579 -219.113)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M260.6,262.521c.212-.261.332.038.494.08C260.889,262.825,260.7,262.93,260.6,262.521Z",
    transform: "translate(-221.089 -222.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M247.9,174.18a1.218,1.218,0,0,0-.182.783c-.125.056-.248.107-.305-.084.319-.126.107-.567.414-.7Z",
    transform: "translate(-210.065 -148.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M145.327,220.98l.1.012c0,.126,0,.251,0,.378l-.253.033C144.943,221.159,145.158,221.077,145.327,220.98Z",
    transform: "translate(-124.534 -187.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M341.62,265.649c-.184-.01-.48.1-.3-.289C341.476,265.394,341.766,265.291,341.62,265.649Z",
    transform: "translate(-288.505 -225.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M233.868,183.18a.409.409,0,0,1,0,.5C233.669,183.512,233.557,183.347,233.868,183.18Z",
    transform: "translate(-198.585 -156.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M357.165,219.77l.294.092a.542.542,0,0,1-.105.407C357.108,220.172,357.172,219.957,357.165,219.77Z",
    transform: "translate(-301.794 -186.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M337.4,132.78a.755.755,0,0,1,.393.222c-.056.117-.138.194-.269.126S337.411,132.906,337.4,132.78Z",
    transform: "translate(-285.277 -114.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M91.44,237.7l.389-.015c-.033.133-.021.325-.209.315C91.479,238,91.47,237.826,91.44,237.7Z",
    transform: "translate(-79.708 -201.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M155.03,238.179l.365-.039c.054.054.154.108.154.163,0,.113-.115.062-.181.067A.291.291,0,0,1,155.03,238.179Z",
    transform: "translate(-132.856 -202.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M355.253,218.083l-.094.2c-.217.02-.322-.118-.4-.291A.91.91,0,0,1,355.253,218.083Z",
    transform: "translate(-299.786 -185.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M359.439,242.127a.485.485,0,0,1-.389.2C359.2,241.968,359.242,241.948,359.439,242.127Z",
    transform: "translate(-303.372 -205.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M537.17,99.81l.588.01C537.557,100.079,537.36,100.063,537.17,99.81Z",
    transform: "translate(-452.241 -86.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M369.292,219.934c-.038-.033-.074-.067-.112-.1.012-.128.012-.259.189-.333C369.464,219.676,369.374,219.8,369.292,219.934Z",
    transform: "translate(-311.838 -186.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M363.493,209.972c-.013-.131-.1-.264.012-.392C363.764,209.718,363.763,209.849,363.493,209.972Z",
    transform: "translate(-307.05 -178.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M104.8,158.105c-.105-.148-.209-.3-.314-.445C104.731,157.713,104.763,157.913,104.8,158.105Z",
    transform: "translate(-90.615 -135.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M339.79,242.632l.489-.112C340.155,242.722,340.026,242.912,339.79,242.632Z",
    transform: "translate(-287.274 -205.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M56.758,237.39l.284.113c-.031.09-.054.21-.181.176C56.719,237.638,56.76,237.5,56.758,237.39Z",
    transform: "translate(-50.718 -201.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M327.23,128.55l.291.1c-.028.074-.056.163-.149.151C327.223,128.785,327.24,128.655,327.23,128.55Z",
    transform: "translate(-276.777 -110.724)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M250.39,207.79l.3-.02a.367.367,0,0,1-.19.3A.412.412,0,0,1,250.39,207.79Z",
    transform: "translate(-212.556 -176.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M361.925,216.5c0-.1-.01-.192-.015-.289.105.02.236.028.232.171C362.135,216.5,362.01,216.484,361.925,216.5Z",
    transform: "translate(-305.762 -183.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.713,224.3l.172.34c-.074.028-.164.08-.222.013C130.557,224.528,130.67,224.415,130.713,224.3Z",
    transform: "translate(-112.453 -190.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.96,127.7c.038-.1.076-.192.112-.289.115.079.2.177.117.317S281.034,127.74,280.96,127.7Z",
    transform: "translate(-238.105 -109.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M269.986,168.188a.76.76,0,0,1-.386.3C269.607,168.224,269.779,168.183,269.986,168.188Z",
    transform: "translate(-228.611 -143.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147.211,88.827c-.392-.11-.225-.253-.023-.4C147.286,88.558,147.23,88.694,147.211,88.827Z",
    transform: "translate(-126.122 -77.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M340.33,268.547c.074-.191.238-.194.4-.191C340.665,268.56,340.5,268.551,340.33,268.547Z",
    transform: "translate(-287.726 -227.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.75,82.5l-.68-.01A.672.672,0,0,1,110.75,82.5Z",
    transform: "translate(-95.279 -72.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M291.379,142.9l.207.207-.015.018c-.161-.011-.33-.007-.391-.207C291.247,142.91,291.313,142.9,291.379,142.9Z",
    transform: "translate(-246.647 -122.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M356.026,242.744c-.136-.011-.174-.074-.1-.194.077.013.176,0,.2.1C356.121,242.676,356.059,242.713,356.026,242.744Z",
    transform: "translate(-300.729 -206.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M261.046,249.853c-.159.161-.159.161-.276-.113A.389.389,0,0,1,261.046,249.853Z",
    transform: "translate(-221.231 -212.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M361.987,213.15l.1-.02c-.008.092,0,.2-.1.245-.026.013-.076-.02-.113-.031C361.916,213.278,361.952,213.214,361.987,213.15Z",
    transform: "translate(-305.737 -181.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M462.611,91.43l.13.107c-.039.108-.1.189-.207.077C462.455,91.53,462.524,91.468,462.611,91.43Z",
    transform: "translate(-389.833 -79.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M234.8,180.85c.1,0,.2.007.3.008,0,.087,0,.174,0,.261l-.3-.077Z",
    transform: "translate(-199.526 -154.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M145.6,217.95l-.015.2c-.072-.016-.184,0-.176-.108S145.524,217.965,145.6,217.95Z",
    transform: "translate(-124.813 -185.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M275.225,146a.28.28,0,0,1-.187.307A.265.265,0,0,1,275.225,146Z",
    transform: "translate(-233.155 -125.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M495.318,87.984l-.108-.181c.089,0,.176,0,.264,0C495.483,87.912,495.555,88.078,495.318,87.984Z",
    transform: "translate(-417.172 -76.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M292.734,138.21c0,.1,0,.2,0,.3C292.542,138.4,292.547,138.307,292.734,138.21Z",
    transform: "translate(-247.827 -118.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M94.627,156.249c-.033.08-.066.161-.1.241l-.207-.057C94.4,156.331,94.409,156.117,94.627,156.249Z",
    transform: "translate(-82.115 -133.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M284.9,140.61c-.038.064-.074.13-.112.194l-.182,0c0-.033,0-.066-.007-.1A.414.414,0,0,1,284.9,140.61Z",
    transform: "translate(-241.148 -120.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M220.09,64.755l-.31.013C219.877,64.594,219.979,64.57,220.09,64.755Z",
    transform: "translate(-186.972 -57.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M140.74,225.732a.239.239,0,0,1,.163-.192l.213.036,0,0A.326.326,0,0,1,140.74,225.732Z",
    transform: "translate(-120.912 -191.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M264,111.715a.123.123,0,0,1,.084.011c-.023.076.028.223-.112.189C263.9,111.9,263.971,111.784,264,111.715Z",
    transform: "translate(-223.879 -96.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M271.289,133.908c-.012,0-.026.015-.036.012s-.016-.018-.023-.028l.057-.021A.272.272,0,0,0,271.289,133.908Z",
    transform: "translate(-229.973 -115.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M273.2,131.724l.2-.094C273.369,131.738,273.323,131.812,273.2,131.724Z",
    transform: "translate(-231.62 -113.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M316.4,125.67l.2.09C316.477,125.846,316.43,125.777,316.4,125.67Z",
    transform: "translate(-267.726 -108.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M330.982,120.81a.234.234,0,0,1-.182.2A.246.246,0,0,1,330.982,120.81Z",
    transform: "translate(-279.761 -104.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M270.233,116.035l-.113-.067.048-.048c.021.038.043.077.066.115Z",
    transform: "translate(-229.046 -100.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M250.918,114.64c0,.011.015.026.012.036s-.018.016-.028.023c-.007-.02-.015-.038-.021-.057Z",
    transform: "translate(-212.965 -99.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M300.77,113.057c.023-.039.046-.079.069-.117l.048.048-.117.069Z",
    transform: "translate(-254.662 -97.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M230.02,111.31l.2.039C230.119,111.5,230.063,111.436,230.02,111.31Z",
    transform: "translate(-195.531 -96.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M212.02,111.378l.2-.018C212.166,111.491,212.1,111.536,212.02,111.378Z",
    transform: "translate(-180.487 -96.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M102.978,156.659a.2.2,0,0,1-.218-.117A.189.189,0,0,1,102.978,156.659Z",
    transform: "translate(-89.169 -134.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M253.7,110.544a.2.2,0,0,1,.222.056.358.358,0,0,1-.279.126C253.66,110.665,253.679,110.6,253.7,110.544Z",
    transform: "translate(-215.272 -95.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M245.921,108.86v.007c-.072.057-.146.115-.218.174a.033.033,0,0,1-.026-.041A.242.242,0,0,1,245.921,108.86Z",
    transform: "translate(-208.616 -94.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M515.56,108.16l.2.01c-.026.039-.044.107-.077.113C515.59,108.3,515.578,108.222,515.56,108.16Z",
    transform: "translate(-434.18 -93.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.41,170.388l-.19.113C267.243,170.4,267.279,170.311,267.41,170.388Z",
    transform: "translate(-226.622 -145.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M258.308,178.587l-.1-.2C258.317,178.418,258.4,178.461,258.308,178.587Z",
    transform: "translate(-219.091 -152.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M259.911,183.18l-.01.2C259.74,183.3,259.762,183.239,259.911,183.18Z",
    transform: "translate(-220.412 -156.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M153.778,96.089l-.038,0c0-.02.011-.039.016-.061.012.007.03.011.033.021S153.781,96.076,153.778,96.089Z",
    transform: "translate(-131.777 -83.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M550.34,94.412c.025-.039.043-.1.077-.112.084-.028.1.051.126.108l-.013.013-.187,0Z",
    transform: "translate(-463.248 -82.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147.432,217.225l-.192.012C147.3,217.125,147.362,217.11,147.432,217.225Z",
    transform: "translate(-126.345 -184.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M113.32,217.69c-.033-.057-.066-.115-.1-.172.072,0,.158-.016.177.079C113.4,217.621,113.348,217.659,113.32,217.69Z",
    transform: "translate(-97.912 -185.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M378.855,219.367l0-.2C379.006,219.232,379.021,219.3,378.855,219.367Z",
    transform: "translate(-319.92 -186.463)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M504.957,86.613l-.2,0c.026-.038.046-.1.079-.107C504.919,86.48,504.937,86.553,504.957,86.613Z",
    transform: "translate(-425.153 -75.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M465.357,86.067l-.187-.036c.03-.036.057-.1.087-.1C465.342,85.924,465.346,86,465.357,86.067Z",
    transform: "translate(-392.065 -75.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M115.01,82.954a.2.2,0,0,1-.2-.057C114.915,82.782,114.968,82.851,115.01,82.954Z",
    transform: "translate(-99.24 -72.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M377.571,232.27l.2-.02a.241.241,0,0,1-.2.222s-.01-.008-.008-.008c0-.066,0-.131,0-.2Z",
    transform: "translate(-318.849 -197.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M373.36,242.634l.1-.094.03.125Z",
    transform: "translate(-315.332 -205.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M269.64,245.668l.192-.108C269.806,245.663,269.766,245.746,269.64,245.668Z",
    transform: "translate(-228.644 -208.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M222.972,64.89c-.071,0-.141-.007-.212-.008C222.839,64.731,222.908,64.749,222.972,64.89Z",
    transform: "translate(-189.463 -57.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M336.843,247.557c0-.066,0-.131,0-.2.057.021.131.039.108.12C336.94,247.513,336.881,247.532,336.843,247.557Z",
    transform: "translate(-284.809 -210.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.415,144.195l-.2.011c.018-.061.031-.138.115-.12C276.368,144.095,276.389,144.157,276.415,144.195Z",
    transform: "translate(-234.144 -123.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M273.025,250.77c.011,0,.028.008.034.016s0,.025,0,.036c-.018-.008-.038-.016-.056-.026C273.008,250.788,273.016,250.78,273.025,250.77Z",
    transform: "translate(-231.453 -212.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M294.8,254.58a.234.234,0,0,1,.209.189A.234.234,0,0,1,294.8,254.58Z",
    transform: "translate(-249.673 -216.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.989,256.161l-.2.082C333.823,256.135,333.875,256.071,333.989,256.161Z",
    transform: "translate(-282.26 -217.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M294.02,256.8c.011,0,.026-.015.036-.011s.016.018.023.028l-.057.021A.309.309,0,0,0,294.02,256.8Z",
    transform: "translate(-249.021 -217.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M482.721,102.995c-.012.008-.023.025-.036.025s-.023-.016-.034-.025c.011-.008.023-.025.034-.025S482.709,102.986,482.721,102.995Z",
    transform: "translate(-406.674 -89.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.89,104.979c.025-.049.049-.1.076-.149.018.053.038.105.056.159C154.977,104.984,154.933,104.981,154.89,104.979Z",
    transform: "translate(-132.739 -90.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M66.245,239.52l-.039.016c0-.013-.016-.034-.012-.038C66.227,239.466,66.245,239.474,66.245,239.52Z",
    transform: "translate(-58.607 -203.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M483.806,107.61c0,.034.01.071.016.105C483.749,107.69,483.7,107.663,483.806,107.61Z",
    transform: "translate(-407.589 -93.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M511.5,108.438a.14.14,0,0,1,.069.011c-.015.034-.03.069-.046.105C511.515,108.515,511.507,108.477,511.5,108.438Z",
    transform: "translate(-430.786 -93.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M389.378,109.987c-.015-.036-.051-.085-.039-.105a.083.083,0,0,1,.141-.02C389.445,109.9,389.411,109.946,389.378,109.987Z",
    transform: "translate(-328.685 -95.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M274.624,63.715l-.074-.025.076.021A.006.006,0,0,1,274.624,63.715Z",
    transform: "translate(-232.748 -56.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M123.24,240.16l.074.023c-.025-.007-.049-.015-.074-.023Z",
    transform: "translate(-106.286 -204.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M143.03,225.536l.062-.046-.062.046Z",
    transform: "translate(-122.826 -191.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M501.17,87.2c0,.039,0,.079,0,.117C501.17,87.279,501.17,87.239,501.17,87.2Z",
    transform: "translate(-422.153 -76.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M90.959,82.97l-.044.015-.044-.015Z",
    transform: "translate(-79.232 -72.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M124.6,83.11l-.1.062C124.534,83.151,124.566,83.13,124.6,83.11Z",
    transform: "translate(-107.339 -72.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M218.107,65.66a.369.369,0,0,0,.012.085l-.118.02C218.034,65.729,218.071,65.694,218.107,65.66Z",
    transform: "translate(-185.485 -58.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M54.86,109.684l.085-.064Z",
    transform: "translate(-49.135 -94.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M102.336,156.191l-.016-.007.023-.025Z",
    transform: "translate(-88.802 -133.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M499.547,88.574l-.1-.094Z",
    transform: "translate(-420.715 -77.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M294.25,125.105c.031-.031.061-.064.092-.1C294.311,125.041,294.281,125.072,294.25,125.105Z",
    transform: "translate(-249.213 -107.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.72,90.941l.025-.031c-.007.011-.011.025-.018.038Z",
    transform: "translate(-127.582 -79.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M528.73,99.193l.151,0C528.832,99.266,528.782,99.321,528.73,99.193Z",
    transform: "translate(-445.187 -86.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M530.36,99.19l.133,0v.125C530.45,99.274,530.4,99.233,530.36,99.19Z",
    transform: "translate(-446.549 -86.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.475,102.82l-.105.007Z",
    transform: "translate(-132.304 -89.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M188.62,64.946l.018-.016-.016.018Z",
    transform: "translate(-160.929 -57.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M268.843,159.476l.78-.3.32.01a2.387,2.387,0,0,0-.12.979l0,0c-.035.067-.067.135-.1.2l0,0a.433.433,0,0,0-.3.1c-.169.053-.213.148-.1.3.059.54-.315,1.026-.2,1.573a.227.227,0,0,0,.181.194c.064.3.131.591.192.887s.217.412.512.3l.094.1c.007.125.013.251.018.376,0,.039-.008.079-.013.118.03.235.054.473.092.706.053.319-.064.45-.388.379l-.108-.1c0-.941-.348-1.294-1.3-1.281-.683.01-1.379.082-1.744-.693-.033-.066-.066-.131-.1-.2q.889-.983,1.78-1.964a.266.266,0,0,0,.291-.3c.4-.4.123-.847.092-1.276A1.287,1.287,0,0,0,268.843,159.476Z",
    transform: "translate(-226.079 -136.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M325.336,158.816a.761.761,0,0,1,.366.383c.071.174.2.379-.011.534s-.45.23-.663,0a7.013,7.013,0,0,0-.759-.755c-.1.274.117.365.2.522.107.215.278.443.043.667s-.483.13-.719-.018c-.2-.125-.32-.368-.619-.438.077.381.614.734.048,1.067-.345.2-.755-.038-1.076-.6.09-.084.529.253.319-.248-.054-.128.2,0,.312-.026.025.112.053.222.071.333s-.187.246.044.315a.193.193,0,0,0,.213-.089c.089-.135.015-.248-.061-.358a.439.439,0,0,0-.263-.209c.01-.136-.34-.361.1-.393l.015.016-.018-.013c.064-.238.143-.627.353-.585a1.273,1.273,0,0,1,.744.708c.092.172-.118.087-.209.074-.026-.008-.03-.084-.077-.025l.079.023c.09.238.279.378.488.22.189-.143-.013-.32-.108-.463a1.659,1.659,0,0,0-.2-.217c-.663-.685-.655-.68-.118-1.545.094-.151.007-.432.333-.358l0,0a.354.354,0,0,0,.4.3l0,0c.135.48.632.718.788,1.182-.437-.12-.626-.539-.949-.795-.184-.146-.309-.205-.332.107-.056.026-.143.036-.115.123.01.033.076.049.117.074.025.041.041.107.074.117.09.026.1-.057.122-.117.172.03.379.12.323.292-.149.465.172.558.466.695l0,0c.049.2.164.342.371.238s.072-.268.013-.412A2.505,2.505,0,0,1,325.336,158.816Z",
    transform: "translate(-272.523 -134.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M299.034,184.365c-.33.176-.529-.125-.8-.261-.067.373.371.815-.135,1.033-.448.194-.606-.32-.916-.491-.128.112,0,.205.023.3.054.194.117.4-.079.537s-.361-.021-.532-.113c-.258-.14-.384-.457-.7-.512a1.462,1.462,0,0,0-.5-.785l0,0c.366-.279.7-.258.938.105.3-.038-.46-.555.236-.394.023.133,0,.3.21.319.062-.194-.105-.24-.2-.328.039-.394.19-.233.342-.069.176.192.22.511.54.565l0,0a.6.6,0,0,0,.076.378c.077.112.171.215.322.171.177-.053.2-.2.166-.356a2.511,2.511,0,0,0-.493-1.007c-.177-.223-.067-.291.117-.429.256-.194.269.043.35.148.158.209.292.434.453.64.074.1.164.251.312.161.125-.077.074-.235.056-.363s-.177-.243-.122-.409C299.057,183.424,299.106,183.6,299.034,184.365Zm-2.082.65c-.015-.08-.039-.169-.143-.146a.2.2,0,0,0-.169.2.142.142,0,0,0,.159.14C296.924,185.209,296.955,185.124,296.952,185.016Zm-.356-.411.089-.028c-.016-.041-.021-.092-.049-.12a.052.052,0,0,0-.094.034C296.539,184.53,296.576,184.567,296.6,184.605Z",
    transform: "translate(-250.166 -156.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M288.619,164.153c.062-.1.123-.207.2-.342.108.243-.039.425-.01.616.021.138-.035.327.164.36s.307-.105.351-.276c.089-.343.161-.69.286-1.031a1.618,1.618,0,0,1-.105,1.314,2.576,2.576,0,0,0-.12,1.849.268.268,0,0,0,.327.232c.227-.051.2-.255.158-.4a1.751,1.751,0,0,1,.189-1.325c.036.539.092,1.076.1,1.614a.416.416,0,0,1-.374.4.508.508,0,0,1-.552-.33,2.082,2.082,0,0,1-.184-1.337c.067-.279.11-.424-.278-.486-.256-.041-.455-.228-.772-.1-.23.1-.388-.115-.36-.381.02-.194.059-.386.09-.58l0,0c.24.071.158.238.128.4-.025.125-.066.287.12.315a.3.3,0,0,0,.3-.207,2.026,2.026,0,0,1,.233-.594c.156.056.085.189.107.286l-.015.011Z",
    transform: "translate(-243.689 -139.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M339.221,176.033a5.287,5.287,0,0,1,1,2.4c.222-.6-.264-1.122-.131-1.7a6.864,6.864,0,0,1,.468,3.457c-.222-1.025-.811-1.923-.959-2.977-.074-.529-.553-.79-.9-1.122a1.242,1.242,0,0,1-.525-.982c.473.227.552.828,1.056.934Z",
    transform: "translate(-285.919 -149.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M284.014,175.587c-.3.115-.452,0-.512-.3s-.128-.591-.192-.887c.236.2.261.512.437.767.1-.583-.391-1.182.064-1.78.279.383-.23.883.24,1.245a2.075,2.075,0,0,1,.151-1.133c.21.292.079.6.105.884a1.389,1.389,0,0,0,.169.8.386.386,0,0,0,.47.172c.2-.084.154-.269.108-.425a1.315,1.315,0,0,1,.077-1.209,12.217,12.217,0,0,1,.158,1.764.274.274,0,0,1-.243.271.726.726,0,0,1-.624-.225,3.638,3.638,0,0,1-.307-.491C284.049,175.251,284.124,175.441,284.014,175.587Z",
    transform: "translate(-240.07 -148.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M288.968,146.422c-.03-.2-.182-.294-.319-.414a.566.566,0,0,1-.184-.7c.159-.365.381-.545.795-.324a1.1,1.1,0,0,0,.636.225c.036-.176-.194-.159-.191-.34a.594.594,0,0,1,.545.135c.089.074.035.187-.011.271-.168.3-.445.049-.667.113,0,.22.378.325.207.548a5.767,5.767,0,0,1-.746.739c-.056.049-.166,0-.2-.092C288.8,146.481,288.89,146.452,288.968,146.422Z",
    transform: "translate(-244.333 -124.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M286.382,156.24a2.387,2.387,0,0,1,.12-.979c.168-.131-.026-.223-.048-.328-.046-.214.054-.263.228-.271l.044.064c-.016-.02-.031-.041-.048-.061.092-.2.172-.072.232.018a.858.858,0,0,1,.064.473c-.259.087-.184.294-.289.558a.561.561,0,0,0,.292-.555c.212.046.388-.028.583-.289-.02.2-.02.284-.036.36-.03.14-.043.276.146.292a.236.236,0,0,0,.264-.235c.026-.256.033-.516.049-.808a1.265,1.265,0,0,1,.046,1.233.5.5,0,0,1-.468.215c-.254-.028-.3-.218-.31-.53a3.124,3.124,0,0,0-.575,1.041l0,0C286.586,156.364,286.515,156.254,286.382,156.24Z",
    transform: "translate(-242.636 -132.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M333.145,179.923c.149-.21-.136-.356-.016-.534a2.517,2.517,0,0,1,.434,2.028c-.281-.263-.3-.622-.429-.911a2.576,2.576,0,0,0-1.342-1.424,1.341,1.341,0,0,1-.624-.6c-.053-.09-.085-.192.018-.259s.141.025.189.1a1.9,1.9,0,0,0,.92.7C332.714,179.182,332.9,179.566,333.145,179.923Z",
    transform: "translate(-280.027 -152.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M323.874,153.01c-.031.179.1.217.186.278a.427.427,0,0,1,.146.563c-.056.141-.133.284-.305.278a.884.884,0,0,1-.644-.309.125.125,0,0,1,0-.177c.076-.079.146-.023.217.016.143.079.3.3.447.061.113-.187-.059-.356-.22-.43-.366-.169-.386-.5-.471-.808.411-.2.874.775,1.222-.151a.516.516,0,0,1,.146.619C324.406,153.328,324.108,152.975,323.874,153.01Z",
    transform: "translate(-273.426 -130.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M279.8,145.985c.159.008.347-.034.434.146.126.261-.184.343-.248.539.1.192.514.08.453.4-.041.215-.258.266-.484.282-.064-.164.2-.159.141-.338-.391.076-.7.378-1.12.419.007-.276.374-.481.167-.8-.008-.013.11-.105.168-.161l0,0,.1-.1,0,0,.1-.1,0,0,.2-.1,0,0c.035-.067.067-.135.1-.2Zm.108.432-.056-.08c-.048.039-.1.077-.143.12a.2.2,0,0,0,.039.057C279.809,146.484,279.86,146.45,279.913,146.417Z",
    transform: "translate(-236.451 -125.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M303.854,171.84c.126.435.5.806.33,1.317-.079.232-.184.425-.458.44s-.4-.169-.483-.4a2.386,2.386,0,0,1-.069-.969c0-.084.033-.184.123-.182a.317.317,0,0,1,.192.128c.174.215.1.46.079.7-.012.126-.077.34.145.343.168,0,.205-.176.235-.327C304.013,172.531,303.749,172.211,303.854,171.84Z",
    transform: "translate(-256.658 -146.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M324.912,145.39c.383.067.571.32.424.66a.551.551,0,0,1-.765.284c-.371-.146-.683-.3-.547-.795.2-.066.307.13.468.184s.289.263.432.167c.19-.126-.007-.325-.016-.494Z",
    transform: "translate(-274.07 -124.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M288.188,187.746c-.007-.125-.012-.251-.018-.376a1.557,1.557,0,0,1,.7.642c.236.335.486.655.974.545.015.046.028.094.044.138.072.181.386.35.179.532-.191.167-.42-.072-.581-.212a4.869,4.869,0,0,1-.824-.888C288.548,187.961,288.431,187.767,288.188,187.746Z",
    transform: "translate(-244.132 -159.885)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M317.347,192.38a6.138,6.138,0,0,1,.1,1.164c-.02.2-.053.434-.251.489s-.315-.138-.4-.3c-.071-.141-.215-.25-.2-.424.044-.064.087-.039.13-.011.14.1.189.389.394.3.235-.107.117-.374.112-.576-.01-.522-.361-.934-.47-1.427C317.129,191.728,317.1,192.157,317.347,192.38Z",
    transform: "translate(-267.889 -163.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M301.475,160.227a2.554,2.554,0,0,1,.082.839c.015.135-.048.335.166.351.187.015.213-.174.259-.31a3.384,3.384,0,0,0,.067-.928c0-.09-.03-.2.082-.259a1.886,1.886,0,0,1-.143,1.613c-.117.14-.251.279-.46.212s-.181-.258-.174-.415A2.576,2.576,0,0,1,301.475,160.227Z",
    transform: "translate(-255.147 -136.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M313.87,161.59c.422.489.429.5-.117.971-.153.133-.072.407-.345.455-.182-.072-.007-.3-.148-.411-.1-.079-.186-.2-.057-.337.107-.115.213-.209.376-.085.087.067.184.085.246-.03a.215.215,0,0,0-.072-.263c-.189-.19-.118-.278.118-.3Z",
    transform: "translate(-265 -138.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M307.315,134.911c.023.094.039.19.069.281s.123.182.018.261a.412.412,0,0,1-.42.021c-.164-.077.038-.151.03-.215-.038-.343-.284-.475-.588-.529-.253-.044-.521.044-.773-.077.415-.251.718-.2,1.668.259Z",
    transform: "translate(-258.741 -115.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M298.662,153.14a1.058,1.058,0,0,1,.126,1.056.386.386,0,0,1-.5.2c-.371-.174-.141-.553-.274-.829.067,0,.107-.007.12.007.13.143.033.521.314.457s.227-.384.186-.629C298.616,153.324,298.56,153.247,298.662,153.14Z",
    transform: "translate(-252.355 -131.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M335.763,186.71c.473.291.347.838.553,1.251-.319-.069-.43-.347-.627-.532-.3-.281-.056-.476.053-.7Z",
    transform: "translate(-283.727 -159.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M319.454,163.7c.374.159.583.291.521.591-.153.734-.747.25-1.125.389.085-.161.012-.529.384-.289.145.092.264.13.388-.012a.278.278,0,0,0-.008-.4A2.688,2.688,0,0,1,319.454,163.7Z",
    transform: "translate(-269.773 -140.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M317.592,156.707c.018-.12-.048-.3.126-.33.614-.1.338-.264.043-.443-.036-.021-.054-.071-.1-.136a.419.419,0,0,1,.563.135.766.766,0,0,1,0,.706c-.09.2-.284.082-.437.074l-.2-.008A.006.006,0,0,0,317.592,156.707Z",
    transform: "translate(-268.72 -133.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M317.3,147.928c.261-.1.458-.11.547.122a1.34,1.34,0,0,1,.148.844c-.03.11-.163.084-.256.054-.138-.043-.309-.066-.342-.232-.028-.138.128-.1.2-.143C317.848,148.414,317.77,148.22,317.3,147.928Z",
    transform: "translate(-268.478 -126.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M282.386,166.48a.417.417,0,0,1,.3-.1c-.038.218-.168.437,0,.657.039.053.064.14,0,.176-.442.255-.412.75-.593,1.136-.118-.548.256-1.035.2-1.575A.382.382,0,0,0,282.386,166.48Z",
    transform: "translate(-239.032 -142.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M326.771,182.435a4.629,4.629,0,0,1-1.409-.593c-.059-.053-.146-.1-.115-.192a.157.157,0,0,1,.107-.066C325.784,181.941,326.422,181.938,326.771,182.435Z",
    transform: "translate(-275.114 -155.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M320.1,176.16c.693.365.754.59.343,1-.069.069-.136.166-.24.085-.074-.057-.02-.153,0-.228C320.345,176.552,320.346,176.552,320.1,176.16Z",
    transform: "translate(-270.818 -150.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M290.777,173.82a5.94,5.94,0,0,0,.061,1.379.191.191,0,0,1-.064.164c-.062.041-.118-.018-.154-.076A2.327,2.327,0,0,1,290.777,173.82Z",
    transform: "translate(-246.128 -148.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M315.25,142.025c.463-.148.65-.046.724.381.02.118.048.238-.1.286a.338.338,0,0,1-.366-.074c-.151-.161.044-.164.115-.232.141-.131.039-.19-.082-.24C315.442,142.107,315.3,142.178,315.25,142.025Z",
    transform: "translate(-266.764 -121.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M306.77,159.778a3.021,3.021,0,0,0,.125-1.8A1.341,1.341,0,0,1,306.77,159.778Z",
    transform: "translate(-259.677 -135.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M357.086,175.149a.953.953,0,0,1-.493-.665c-.021-.1-.085-.241.074-.287a.207.207,0,0,1,.236.135A1.275,1.275,0,0,1,357.086,175.149Z",
    transform: "translate(-301.292 -148.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M315.783,136.277c.023-.084.074-.179.159-.131.236.133.406.427.757.205.084-.053.163.128.174.241.02.172-.105.171-.223.164-.371-.016-.6-.287-.87-.484Z",
    transform: "translate(-267.207 -117.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.158,148.683c-.048-.094-.271-.077-.192-.228.056-.108.218-.08.307,0a.63.63,0,0,1,.151.68c-.059.245-.243.274-.514.159.235-.159.471-.317.243-.611Z",
    transform: "translate(-261.466 -127.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.478,156.19c.067-.353.253-.7-.278-.931.337-.1.522-.013.614.2C309.96,155.8,309.7,155.987,309.478,156.19Z",
    transform: "translate(-261.708 -133.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M310.019,167.9a1.138,1.138,0,0,1,.235.862.25.25,0,0,1-.259.241.224.224,0,0,1-.164-.08c-.1-.169.1-.151.153-.225C310.17,168.457,309.838,168.189,310.019,167.9Z",
    transform: "translate(-262.212 -143.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M348.806,173.752c-.34-.131-.4-.4-.514-.644-.039-.085-.054-.2.057-.25a.174.174,0,0,1,.225.13C348.663,173.239,348.73,173.5,348.806,173.752Z",
    transform: "translate(-294.356 -147.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M305.484,185.908l-.494-1c.545.271.575.759.856,1.067-.189.146-.253-.048-.365-.071C305.484,185.907,305.484,185.908,305.484,185.908Z",
    transform: "translate(-258.189 -157.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M315.54,180.21c.159.217.665-.043.626.447-.007.094.023.207-.09.255-.094.039-.153-.039-.194-.107C315.77,180.612,315.553,180.487,315.54,180.21Z",
    transform: "translate(-267.007 -153.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M342.2,175.614c-.066-.3-.312-.491-.425-.76-.036-.087-.1-.192.03-.248.092-.041.169.044.187.113.079.294.621.486.205.892Z",
    transform: "translate(-288.896 -149.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M322.3,142.411a2.747,2.747,0,0,1-1.2-.471c.424.1.9.048,1.2.47Z",
    transform: "translate(-271.654 -121.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M316.366,170.767c.351.2.54,0,.69-.427.123.46-.031.68-.3.783s-.384-.087-.409-.338Z",
    transform: "translate(-267.684 -145.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M299.17,175.061a2.358,2.358,0,0,1-.026-1.4C299.069,174.133,299.28,174.6,299.17,175.061Z",
    transform: "translate(-253.225 -148.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M323.92,137.52c.2.264.248.708.611.314.039-.043.105.049.108.115.01.151-.049.266-.215.253C324.094,138.175,323.883,138.022,323.92,137.52Z",
    transform: "translate(-274.007 -118.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M311.339,178.519c.011-.107-.126-.245,0-.314s.2.079.258.169c.107.171.276.315.274.567-.264-.072-.286-.393-.535-.427C311.336,178.516,311.339,178.519,311.339,178.519Z",
    transform: "translate(-263.451 -152.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M335.166,177.461a.521.521,0,0,1-.466-.486c0-.021.085-.08.1-.071C335.025,177.026,335.056,177.267,335.166,177.461Z",
    transform: "translate(-283.02 -151.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M296.1,164.954c-.012-.044-.041-.092-.034-.133a2.909,2.909,0,0,1,.182-.7c.156.292-.038.557-.03.836Z",
    transform: "translate(-250.729 -140.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M319.28,188.93a.589.589,0,0,1,.279.537C319.311,189.267,319.311,189.267,319.28,188.93Z",
    transform: "translate(-270.133 -161.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M294,189.78c.013.126.025.255.041.42a.372.372,0,0,1-.315-.317c0-.163.181-.062.276-.1Z",
    transform: "translate(-248.778 -161.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M308.992,144.89a.2.2,0,0,1,.021.33c-.046.046-.159.059-.164,0A.335.335,0,0,1,308.992,144.89Z",
    transform: "translate(-261.413 -124.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M314.187,172.487c-.033.135.11.273,0,.419-.22-.122-.177-.328-.189-.516l0,0,.2.1S314.187,172.487,314.187,172.487Z",
    transform: "translate(-265.711 -147.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M321.685,144.729c-.034.041-.056.089-.087.1a.091.091,0,0,1-.12-.1.118.118,0,0,1,.085-.079C321.6,144.65,321.634,144.693,321.685,144.729Z",
    transform: "translate(-271.97 -124.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M303.741,149.54a.345.345,0,0,1,.292.3l-.015.015a.352.352,0,0,1-.3-.294Z",
    transform: "translate(-257.128 -128.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M284.6,141.793l.182,0c0,.1,0,.2-.008.3l-.182,0C284.593,141.989,284.595,141.892,284.6,141.793Z",
    transform: "translate(-241.139 -121.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M312.771,183.16c.089.069.184.133.153.271-.209.008-.138-.156-.164-.259Z",
    transform: "translate(-264.683 -156.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M300.488,150.874c-.021.016-.046.048-.061.044a.09.09,0,0,1-.054-.057c-.008-.054.021-.085.076-.059C300.47,150.812,300.477,150.849,300.488,150.874Z",
    transform: "translate(-254.329 -129.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M306.774,143.069a.779.779,0,0,1-.174.046c-.038,0-.1,0-.076-.067.007-.016.054-.03.08-.028A1.37,1.37,0,0,1,306.774,143.069Z",
    transform: "translate(-259.467 -122.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M311.765,181.665a.266.266,0,0,1-.2-.3l.01-.01a.388.388,0,0,1,.2.3Z",
    transform: "translate(-263.689 -154.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M315.379,172.39l-.189-.013,0,0c.021-.059.033-.14.12-.118.034.008.057.071.085.108A.222.222,0,0,0,315.379,172.39Z",
    transform: "translate(-266.714 -147.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M313.221,176.5c-.01-.01-.021-.018-.031-.028l.059-.034c0,.015.015.031.01.041S313.233,176.5,313.221,176.5Z",
    transform: "translate(-265.043 -150.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M316.291,176.99c0,.013.017.028.013.039s-.02.016-.031.026c-.008-.021-.016-.043-.023-.064A.361.361,0,0,0,316.291,176.99Z",
    transform: "translate(-267.6 -151.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M314.4,178.21c.013,0,.03-.016.041-.013s.018.021.026.033c-.021.008-.043.016-.064.023A.373.373,0,0,1,314.4,178.21Z",
    transform: "translate(-266.054 -152.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M310.906,180.392c-.186-.074-.164-.14.007-.2l0,0,0,.194Z",
    transform: "translate(-263.024 -153.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M293.575,144.15l.08.036c-.046.062-.066,0-.1-.018Z",
    transform: "translate(-248.636 -123.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M336.511,186.345c-.015-.03-.077-.051-.018-.1l.039.076A.262.262,0,0,1,336.511,186.345Z",
    transform: "translate(-284.498 -158.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M285.79,165.382c.034-.067.067-.135.1-.2C285.857,165.247,285.824,165.315,285.79,165.382Z",
    transform: "translate(-242.142 -141.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M328.584,144.9l-.194-.1,0,0,.2.1Z",
    transform: "translate(-277.747 -124.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M303.646,149.476l-.016-.036.036.016Z",
    transform: "translate(-257.053 -128.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M313.926,172.323l-.016-.013.013.015Z",
    transform: "translate(-265.644 -147.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M270.214,206.369a.8.8,0,0,1,.09-.015c.222,0,.455.039.6-.2a.527.527,0,0,0,.391-.1l0,0,.391,0a.123.123,0,0,0,.2,0l.488-.1c.067.067.136.133.2.2l.683.112c.076.475.333-.03.476.089.016.159.013.379.223.361.351-.028.747.008.979-.365a.411.411,0,0,1,.108-.3c.2.212.161.744.688.5a.281.281,0,0,0,.3-.222l.678.435a5.933,5.933,0,0,0-.307,1.37.834.834,0,0,0-.681.386l-.407-.087c-.291-.222-.483-.711-.989-.348-.039.028-.176-.062-.256-.115a1.226,1.226,0,0,0-.412-.253c-.1-.222-.232-.163-.371-.049-.11.089-.217.179-.327.269l-.278,0c-.108-.1-.3-.189-.309-.3a.7.7,0,0,0-.639-.718,1.587,1.587,0,0,0-1.026-.031C270.266,207.082,270.2,206.717,270.214,206.369Z",
    transform: "translate(-229.123 -175.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M324.52,203.843a1.082,1.082,0,0,0-.016-.678c-.136-.286.118-.565.31-.8h.4l0,0c-.092.5-.038.555.5.494l0,0a.372.372,0,0,0,.3.2l0,0,.2.1,0,0c-.238.417-.057.7.314.893.105.056.238.342.366-.059.054-.169.32.059.406.25l0,0c-.3.03-.3.154-.089.317.154.117.347.064.524.079.107.008.269-.023.259.14-.008.136-.163.136-.276.145a1,1,0,0,1-.655-.148.47.47,0,0,0-.547-.077c.041.228.31.054.381.228-.034.135-.154.1-.24.1a1.768,1.768,0,0,1-1.829-.915c-.051-.108-.189-.174-.287-.259A.016.016,0,0,0,324.52,203.843Zm1.086-.695-.025-.018.02.023c.015.058.023.118.1.122.01,0,.03-.018.028-.028C325.726,203.17,325.66,203.166,325.606,203.148Z",
    transform: "translate(-274.467 -172.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M278.518,192.945l-.488.1c-.067-.064-.135-.128-.2-.192l0,0-.1-.1,0,0c-.1-.159-.269-.307-.107-.519a.382.382,0,0,1,.384-.158.242.242,0,0,1,.153.1c.038.066-.011.122-.085.135-.108.018-.273.007-.174.182a.348.348,0,0,0,.388.143.969.969,0,0,0,.721-1.156c.324.071.44-.059.388-.379-.039-.235-.062-.471-.092-.706.251.309.532.616.4,1.058-.057.189.179.223.166.322-.635.133-.775.741-1.154,1.082l0,0Z",
    transform: "translate(-235.263 -162.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M314.556,210.144c.061.22.13.438.177.662a.312.312,0,0,1-.117.35c-.135.09-.246.011-.358-.061-.417-.271-.576-.729-.888-1.2.4.082.366.547.693.549.018.021-.026.092.053.067l-.053-.067c.108-.187-.305-.3-.057-.527.384-.351.383.125.552.233Z",
    transform: "translate(-265.193 -178.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M334.638,221.717a1.436,1.436,0,0,0-1.455,1c-.123.3-.434.435-.884.223a1.123,1.123,0,0,0,.972-.928c.092-.305.473-.3.673-.53C334.248,221.131,334.377,221.643,334.638,221.717Z",
    transform: "translate(-281.014 -188.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M274.764,215.14c-.071.273-.121.64-.506.65-.358.01-.461-.3-.473-.619s.092-.568.445-.571A.487.487,0,0,1,274.764,215.14Zm-.322-.025c-.015-.123-.071-.222-.209-.222-.163,0-.222.117-.233.26-.01.118,0,.251.154.251C274.326,215.4,274.4,215.275,274.442,215.115Z",
    transform: "translate(-232.109 -182.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M325.72,240.641c-.442.054-.883.108-1.42.172.332-.415.729-.24,1.046-.327.2-.054.517-.245.642.031.166.365-.209.438-.445.56-.1.051-.228.071-.223.223,0,.118-.031.2-.166.156a.338.338,0,0,1-.2-.123c-.051-.1.041-.176.108-.248a1.67,1.67,0,0,1,.688-.327C325.74,240.72,325.73,240.681,325.72,240.641Z",
    transform: "translate(-274.328 -204.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M267.19,233.926a.944.944,0,0,1,.847.133,2.416,2.416,0,0,0,1.2.365c.094,0,.23-.007.23.118,0,.148-.145.164-.256.153a3.341,3.341,0,0,1-.476-.094C268.18,234.46,267.734,234.09,267.19,233.926Z",
    transform: "translate(-226.597 -198.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M278.994,230.741c-.021.273-.154.447-.424.442-.3-.007-.419-.232-.437-.488a.394.394,0,0,1,.419-.435C278.829,230.262,278.958,230.485,278.994,230.741Zm-.227-.021c-.026-.069-.062-.163-.177-.164-.153,0-.176.11-.166.228s.064.184.182.164S278.764,230.853,278.767,230.72Z",
    transform: "translate(-235.742 -195.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M304.247,242.865c-.489-.465-.516-1.169-.877-1.7C304.033,241.526,304.027,242.257,304.247,242.865Z",
    transform: "translate(-256.835 -204.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M308.344,226.07c-.008-.248-.151-.493.074-.742s.3-.158.4.072a.472.472,0,0,1-.479.667Z",
    transform: "translate(-260.949 -191.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M310.368,204.12a2.155,2.155,0,0,1,.327.2c.227.2.435.388.514-.1.153.067.126.179.128.268,0,.158.056.353-.117.44-.213.11-.317-.1-.432-.22-.166-.172-.381-.31-.438-.568Z",
    transform: "translate(-262.669 -173.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M306.271,205.7l-.678-.435c0-.09-.008-.181-.013-.271l.007,0c.248,0,.34.287.578.33.133-.21-.115-.388-.041-.639C306.391,205.023,306.665,205.311,306.271,205.7Z",
    transform: "translate(-258.682 -174.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M297.882,237.992c-.2-.062-.555.082-.552-.133,0-.287.361-.164.563-.166s.6-.105.59.123C298.473,238.117,298.087,237.915,297.882,237.992Z",
    transform: "translate(-251.787 -201.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.352,244.44a1.552,1.552,0,0,0,.066.19c.181.379.274.795.46,1.177-.484-.283-.542-.787-.708-1.232C309.231,244.529,309.291,244.484,309.352,244.44Z",
    transform: "translate(-261.683 -207.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M285.28,205.52l-.683-.112q0-.148,0-.3l0,0a1.642,1.642,0,0,1,1.163.151C285.488,205.239,285.446,205.465,285.28,205.52Z",
    transform: "translate(-241.139 -174.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M299.98,203.188c-.527.246-.491-.286-.688-.5-.021-.222-.043-.443-.072-.76.236.256.163.519.259.724.143.3.281.363.5.028Z",
    transform: "translate(-253.367 -172.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M289.427,201.16c.315-.057.3.21.338.4.031.153-.043.281-.212.236-.2-.053-.512,0-.514-.332C289.036,201.255,289.2,201.16,289.427,201.16Zm.076.351c-.023-.08-.057-.161-.151-.164a.1.1,0,0,0-.092.135.253.253,0,0,0,.128.126C289.457,201.636,289.506,201.595,289.5,201.511Z",
    transform: "translate(-244.858 -171.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M292.882,207.35c-.232.373-.627.337-.979.365-.21.016-.205-.2-.223-.361a.5.5,0,0,1,.31-.2l.013.015c-.011.225.028.384.319.3C292.5,207.413,292.695,207.388,292.882,207.35Z",
    transform: "translate(-247.065 -176.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M293.31,197.19c.2.105.187.3.263.457.059.12.118.236.274.236.089,0,.177-.294.261-.007a.266.266,0,0,1-.13.294c-.146.089-.246-.013-.338-.105A1.533,1.533,0,0,1,293.31,197.19Z",
    transform: "translate(-248.427 -168.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M322.39,208.292c.343-.259-.092-.516.026-.842.2.2.172.5.37.647l0,0v.723a.621.621,0,0,1-.391-.524S322.39,208.292,322.39,208.292Z",
    transform: "translate(-272.732 -176.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M283.692,237.535c-.437.015-.652-.266-.9-.645C283.268,236.952,283.458,237.273,283.692,237.535Z",
    transform: "translate(-239.635 -201.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M310.45,212.36c.373.128.425.53.749.6.015,0,.033.108.016.122-.048.034-.13.08-.167.062A.936.936,0,0,1,310.45,212.36Z",
    transform: "translate(-262.753 -180.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M316.065,194.663a7.863,7.863,0,0,0-.565-1.12.112.112,0,0,1,.029-.171.114.114,0,0,1,.163.054A2.134,2.134,0,0,1,316.065,194.663Z",
    transform: "translate(-266.95 -164.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M284.35,250.474a.642.642,0,0,1,.759.113c.018.016,0,.118-.021.122A1,1,0,0,1,284.35,250.474Z",
    transform: "translate(-240.939 -212.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M325.49,249.5l-.9.248A.649.649,0,0,1,325.49,249.5Z",
    transform: "translate(-274.571 -211.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.63,219.459c.347,0,.529.092.522.488A.956.956,0,0,1,280.63,219.459Z",
    transform: "translate(-237.83 -186.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M312.073,198.3c-.131-.238-.263-.476-.463-.836A.749.749,0,0,1,312.073,198.3Z",
    transform: "translate(-263.722 -168.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M315.583,230.131c-.126.01-.19-.041-.2-.131-.008-.166.123-.21.251-.243.094-.023.169.013.163.115A.314.314,0,0,1,315.583,230.131Z",
    transform: "translate(-266.88 -195.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M321.8,225.6c-.1,0-.177-.041-.166-.135.015-.138.143-.164.255-.182.079-.013.19-.01.186.1C322.066,225.539,321.918,225.565,321.8,225.6Z",
    transform: "translate(-272.099 -191.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M314.33,195.9a.78.78,0,0,1,.235.571A.519.519,0,0,1,314.33,195.9Z",
    transform: "translate(-265.988 -167.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M320.241,208.436c-.02-.189-.038-.376-.071-.7a2.452,2.452,0,0,1,.365.795l0,0-.3-.1Z",
    transform: "translate(-270.876 -176.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.935,223.52c.084.01.171.031.182.125s-.072.131-.158.13-.174-.016-.182-.117S280.846,223.525,280.935,223.52Z",
    transform: "translate(-237.952 -190.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M293.58,205.352c.19-.212.361-.476.713-.286-.069.036-.138.071-.205.107-.163.071-.3.2-.494.194A.1.1,0,0,1,293.58,205.352Z",
    transform: "translate(-248.653 -174.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M310.8,235.932c-.08-.008-.131-.049-.131-.122a.18.18,0,0,1,.179-.192.111.111,0,0,1,.125.118A.185.185,0,0,1,310.8,235.932Z",
    transform: "translate(-262.937 -200.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.046,197.93a.225.225,0,0,1,.236.194.063.063,0,0,1-.084.079C309.083,198.153,308.97,198.093,309.046,197.93Z",
    transform: "translate(-261.558 -168.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M335.95,209.3a.272.272,0,0,1,.281.268C336.072,209.556,336,209.476,335.95,209.3Z",
    transform: "translate(-284.065 -178.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.123,201.928a.547.547,0,0,1-.243-.448.441.441,0,0,1,.261.434A.174.174,0,0,0,309.123,201.928Z",
    transform: "translate(-261.44 -171.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M302.578,202.35a.53.53,0,0,1,.3.394l-.008.008c-.169-.077-.305-.181-.3-.392C302.567,202.36,302.578,202.35,302.578,202.35Z",
    transform: "translate(-256.165 -172.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M300.79,201.173a.257.257,0,0,1,.3.191l-.01.01a.379.379,0,0,1-.289-.2Z",
    transform: "translate(-254.679 -171.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M304.388,204.75a.259.259,0,0,1,.2.3l-.007,0a.4.4,0,0,1-.2-.294S304.388,204.75,304.388,204.75Z",
    transform: "translate(-257.68 -174.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M312.6,202.8c.012.028.034.056.031.082s-.043.026-.067.039c-.013-.026-.036-.056-.035-.08S312.576,202.813,312.6,202.8Z",
    transform: "translate(-264.491 -172.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M311.39,200.99c.013,0,.03-.016.041-.013s.018.021.026.033l-.066.025A.407.407,0,0,0,311.39,200.99Z",
    transform: "translate(-263.538 -171.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M296.66,205.507c.069-.036.138-.071.205-.107l.089,0c0,.023,0,.044,0,.067A.2.2,0,0,1,296.66,205.507Z",
    transform: "translate(-251.227 -174.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M325.388,217.37l-.118-.069.049-.051c.023.039.046.079.069.117A0,0,0,0,1,325.388,217.37Z",
    transform: "translate(-275.139 -184.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M309.661,253.244c-.015,0-.03.016-.043.013s-.018-.021-.028-.033l.066-.025A.2.2,0,0,1,309.661,253.244Z",
    transform: "translate(-262.034 -214.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M307.62,199.93h.028l-.015.026Z",
    transform: "translate(-260.387 -170.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M341.592,213.77l.018.021-.02-.02Z",
    transform: "translate(-288.779 -181.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M298.453,205.477c0-.023,0-.044,0-.067A.05.05,0,0,1,298.453,205.477Z",
    transform: "translate(-252.723 -174.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M300.718,201.088l-.018-.018.015.02Z",
    transform: "translate(-254.604 -171.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M464.907,93.82a.406.406,0,0,1,0,.521c-.122-.194.028-.36,0-.521A0,0,0,0,0,464.907,93.82Z",
    transform: "translate(-391.802 -81.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M530.273,92.079a.264.264,0,0,1-.281.218c-.031-.223.161-.179.269-.228C530.262,92.068,530.273,92.079,530.273,92.079Z",
    transform: "translate(-446.24 -80.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M467.284,96.83v.292C467.089,97.025,467.089,96.929,467.284,96.83Z",
    transform: "translate(-393.709 -84.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M466.467,90.558c-.023-.033-.054-.066-.049-.071a.354.354,0,0,1,.087-.077s.048.044.044.049A.837.837,0,0,1,466.467,90.558Z",
    transform: "translate(-393.107 -78.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M504.628,98.458a1.244,1.244,0,0,1-.066.159c0,.008-.054-.007-.082-.012l.108-.186C504.6,98.431,504.615,98.445,504.628,98.458Z",
    transform: "translate(-424.919 -85.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M529.025,95.74c-.1,0-.2,0-.305,0C528.822,95.643,528.925,95.579,529.025,95.74Z",
    transform: "translate(-445.179 -83.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M522.309,90.668c-.012-.011-.031-.025-.03-.033a.7.7,0,0,1,.03-.076c.01.01.029.023.028.03A.351.351,0,0,1,522.309,90.668Z",
    transform: "translate(-439.796 -78.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M474.779,96c.044.026.148.033.1.105s-.1,0-.125-.064C474.76,96.026,474.771,96.013,474.779,96Z",
    transform: "translate(-400.072 -83.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M510.8,88.9c-.046-.048-.092-.1-.138-.141l.107-.076c.044.043.087.085.13.13Z",
    transform: "translate(-430.085 -77.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M117.738,88.25c0,.011.015.026.011.036s-.018.016-.028.023c-.007-.02-.015-.038-.021-.057Z",
    transform: "translate(-101.656 -77.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M149.723,102.832l-.113,0C149.646,102.832,149.686,102.832,149.723,102.832Z",
    transform: "translate(-128.326 -89.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M265.886,162.677q-.889.983-1.78,1.964a.466.466,0,0,0-.153.557c.043.176.1.351-.141.434-.34-1-.271-1.159.509-1.915a7.248,7.248,0,0,0,1.166-1.176.79.79,0,0,0-.128-1.163c-.1-.089-.31-.169-.148-.327.12-.117.282,0,.378.115A1.515,1.515,0,0,1,265.886,162.677Z",
    transform: "translate(-223.611 -137.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M267.2,184.36c.366.775,1.061.7,1.744.693.954-.013,1.3.34,1.3,1.281-.041.087-.061.223-.128.253-.168.074-.294.374-.478.227-.158-.126.1-.269.163-.4a.7.7,0,0,0-.483-1.059,5.99,5.99,0,0,0-1.123-.1C267.5,185.207,267.259,184.986,267.2,184.36Z",
    transform: "translate(-226.605 -157.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M269.594,199.343c.018-.094,0-.217.125-.24s.146.1.166.19l.143.716c-.084.225-.435-.4-.448.177.1-.31-.562-.567.015-.844.02.1-.041.223.105.317A.366.366,0,0,0,269.594,199.343Z",
    transform: "translate(-228.406 -169.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M273.562,196.558c-.059.238.1.391.148.575.035.135.082.325-.112.368-.156.034-.209-.13-.235-.256-.043-.207-.076-.415-.1-.624-.025-.179.023-.37.225-.355C273.71,196.282,273.495,196.479,273.562,196.558Z",
    transform: "translate(-231.665 -167.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M276.753,196.62a.212.212,0,0,1-.2.278.176.176,0,0,1-.207-.209c.013-.163.053-.361.243-.371C276.757,196.308,276.7,196.519,276.753,196.62Z",
    transform: "translate(-234.247 -167.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M277,205.054l-.391,0c-.141-.34.12-.274.3-.292l0,0,.1.1,0,0C277,204.924,277,204.99,277,205.054Z",
    transform: "translate(-234.432 -174.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M258.382,189.153l-.2-.192c.1-.08.049-.365.232-.269C258.615,188.8,258.324,188.989,258.382,189.153Z",
    transform: "translate(-219.066 -160.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M274.8,206.336a.527.527,0,0,1-.391.1C274.486,206.174,274.665,206.344,274.8,206.336Z",
    transform: "translate(-232.631 -175.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M252.43,177.725l.016-.025.012.026Z",
    transform: "translate(-214.261 -151.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44.84,88.254a.5.5,0,0,0-.2-.491c.245.015.53-.108.68.213.041.09.273.057.172.232a.242.242,0,0,1-.371.1A.927.927,0,0,0,44.84,88.254Z",
    transform: "translate(-40.594 -76.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M53.1,97.159c-.21.207-.519.187-.757.33A.49.49,0,0,1,52.065,97C52.411,97.053,52.755,97.105,53.1,97.159Z",
    transform: "translate(-46.797 -84.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.241,101.02c.015.409-.351.437-.591.591A.736.736,0,0,1,63.241,101.02Z",
    transform: "translate(-55.646 -87.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M50.94,91.855c-.156-.053-.361-.016-.4-.215-.015-.077.082-.156.159-.151C50.918,91.5,50.833,91.75,50.94,91.855Z",
    transform: "translate(-45.525 -79.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M60.942,94.55a.551.551,0,0,1-.452-.33.524.524,0,0,1,.455.327Z",
    transform: "translate(-53.841 -82.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M47.05,94.426l.112.069c-.016.015-.031.03-.048.046-.021-.039-.043-.077-.064-.115Z",
    transform: "translate(-42.608 -82.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.243,96.22l.12.069c-.089.067-.084-.041-.123-.066C63.24,96.222,63.243,96.22,63.243,96.22Z",
    transform: "translate(-56.139 -83.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M51.852,86.62l0,0S51.852,86.62,51.852,86.62Z",
    transform: "translate(-46.62 -75.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M348.252,157.267a.681.681,0,0,1,.245.355c.067.143.227.309.067.438a.38.38,0,0,1-.521-.122,22.345,22.345,0,0,1-1.66-2.348l0,0a6.534,6.534,0,0,1,1.343,1.524c.164.194.22.489.525.548l.026.016-.016-.026c0-.13,0-.261,0-.391Z",
    transform: "translate(-292.782 -133.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M341.676,160.647a6.859,6.859,0,0,1-1.406-1.517A3.7,3.7,0,0,1,341.676,160.647Z",
    transform: "translate(-287.676 -136.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M334.787,157.689a.352.352,0,0,1-.4-.3A.516.516,0,0,1,334.787,157.689Z",
    transform: "translate(-282.761 -134.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M350.537,165.954c-.062-.041-.131-.08-.128-.169,0-.012.039-.023.061-.035.023.069.044.136.067.2Z",
    transform: "translate(-296.15 -141.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M345.18,154.393a.23.23,0,0,1,.2.2l0,0a.255.255,0,0,1-.2-.2Z",
    transform: "translate(-291.779 -132.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M345.116,154.315l-.016-.015.013.018Z",
    transform: "translate(-291.712 -132.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M304.85,63.26",
    transform: "translate(-258.072 -56.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M115.656,140.989c0,2.411-.02,4.823,0,7.234,0,.455-.126.581-.571.568-1-.031-2-.015-3,0-.287,0-.4-.076-.4-.386q.017-3.542,0-7.086c0-.269.087-.381.368-.378,1.2.015,2.394.013,3.591.018C115.643,140.956,115.656,140.989,115.656,140.989Z",
    transform: "translate(-96.624 -121.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M108.8,166.95c.01-.084.021-.166.031-.25.053.053.148.105.149.159C108.984,166.956,108.874,166.94,108.8,166.95Z",
    transform: "translate(-94.217 -142.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M108.21,168.489l.1-.049Q108.262,168.467,108.21,168.489Z",
    transform: "translate(-93.724 -144.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M110.251,223.226l-.025.031a.089.089,0,0,1-.016-.036c0-.011.015-.021.023-.031A.248.248,0,0,1,110.251,223.226Z",
    transform: "translate(-95.396 -189.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.766,257.5l.09.209,0,0-.11-.189Z",
    transform: "translate(-227.065 -218.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.675,257.441l-.015-.031.031.016Z",
    transform: "translate(-226.99 -218.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M304.582,140.092l-.2-.1C304.447,140.024,304.515,140.059,304.582,140.092Z",
    transform: "translate(-257.68 -120.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.32,200.742c.094-.018.238,0,.269-.059.059-.1-.064-.163-.141-.217q-1.237-.889-2.475-1.775c-.09-.064-.2-.113-.223-.241.169-.092.259.039.356.105.91.613,1.82,1.225,2.719,1.851.169.117.522.22.36.48s-.5.143-.757.013c-.048-.026-.074-.1-.108-.156Z",
    transform: "translate(-279.719 -169.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M329.305,202.874c-.532.059-.586.007-.5-.494l.3,0,0,0C329.171,202.544,329.238,202.708,329.305,202.874Z",
    transform: "translate(-278.068 -172.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M337.81,206.79c.3.038.415.1.486.287C338.061,207.1,338,206.964,337.81,206.79Z",
    transform: "translate(-285.62 -176.116)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M330.19,200.582c.09.021.191.039.223.14s-.053.128-.125.154l0,0-.1-.3Z",
    transform: "translate(-279.251 -170.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M343.943,210.625c0,.072-.03.108-.08.092a.153.153,0,0,1-.09-.09.058.058,0,0,1,.077-.076C343.888,210.562,343.918,210.6,343.943,210.625Z",
    transform: "translate(-290.599 -179.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M332.279,205.569a.372.372,0,0,1-.3-.2C332.124,205.37,332.244,205.406,332.279,205.569Z",
    transform: "translate(-280.747 -174.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.064,202.871c-.013,0-.028.015-.039.013s-.016-.02-.025-.031l.062-.023A.348.348,0,0,0,333.064,202.871Z",
    transform: "translate(-281.6 -172.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M335.506,204.595c0,.013-.008.03-.018.036s-.025,0-.038,0c.008-.02.018-.038.026-.057Z",
    transform: "translate(-283.647 -174.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M342,209.482l-.033-.028.061-.034c0,.015.015.031.01.043S342.016,209.476,342,209.482Z",
    transform: "translate(-289.096 -178.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M328.32,199.114c.012,0,.026-.011.036-.008s.015.018.023.028l-.054.016C328.323,199.139,328.322,199.127,328.32,199.114Z",
    transform: "translate(-277.688 -169.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.99,206.67l-.2-.1C333.856,206.6,333.923,206.637,333.99,206.67Z",
    transform: "translate(-282.26 -175.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M346.29,212.471l-.02-.021.021.02Z",
    transform: "translate(-292.69 -180.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M330.108,200.5l-.018-.016.016.018Z",
    transform: "translate(-279.167 -170.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M364.635,248.56l-.064.051c-.02-.074.046-.031.067-.049Z",
    transform: "translate(-307.983 -211.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M351.17,252.479l.072-.049c.038.077-.039.043-.061.062Z",
    transform: "translate(-296.786 -214.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M364.983,248.177l.02-.077c-.008.025-.015.049-.023.074C364.98,248.175,364.983,248.177,364.983,248.177Z",
    transform: "translate(-308.328 -210.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M355.98,247.452l.1-.1C356.047,247.384,356.014,247.419,355.98,247.452Z",
    transform: "translate(-300.806 -210.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M355.38,248.043l.1-.1C355.447,247.976,355.414,248.011,355.38,248.043Z",
    transform: "translate(-300.304 -210.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M279.11,261.666l-.02-.016.018.018Z",
    transform: "translate(-236.543 -221.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M296.493,253.347l-.023.016.018-.023Z",
    transform: "translate(-251.068 -215.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M376.644,232.36c0,.066,0,.131,0,.2-.061.015-.172.046-.172.041C376.419,232.442,376.56,232.422,376.644,232.36Z",
    transform: "translate(-317.921 -197.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M372.18,235.03c.015-.072.02-.154.107-.181.012,0,.053.033.051.048-.007.092-.08.117-.154.136C372.183,235.035,372.18,235.03,372.18,235.03Z",
    transform: "translate(-314.345 -199.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M380.672,209.56c-.034.067-.067.135-.1.2C380.6,209.695,380.639,209.627,380.672,209.56Z",
    transform: "translate(-321.358 -178.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M375.688,231.76l-.018.02.02-.018Z",
    transform: "translate(-317.262 -196.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M276.778,160.409c.031.43.305.877-.092,1.276,0-.537.1-1.1-.5-1.485C276.532,160.1,276.61,160.345,276.778,160.409Z",
    transform: "translate(-234.119 -137.155)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.435,91.373c.251,0,.437.034.434.309,0,.227-.089.366-.343.376-.309.011-.33-.181-.338-.414C141.179,91.431,141.251,91.332,141.435,91.373Z",
    transform: "translate(-121.285 -79.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M141.346,84.85c.248.01.374.133.36.373-.013.213-.092.381-.351.378-.227,0-.278-.145-.253-.327S141.032,84.848,141.346,84.85Z",
    transform: "translate(-121.209 -74.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M226.328,204.7l-.018-.016.016.016Z",
    transform: "translate(-192.43 -174.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M125.084,86.235c-.025.287-.013.685-.516.714-.373.021-.647-.376-.639-.887.008-.565.176-.8.563-.793C124.9,85.276,125.088,85.568,125.084,86.235Z",
    transform: "translate(-106.862 -74.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M295.682,111.726l-.292-.064c.026-.077.061-.163.154-.154C295.668,111.52,295.671,111.63,295.682,111.726Z",
    transform: "translate(-250.166 -96.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M292.872,110.614c-.064.043-.128.071-.192,0l.14-.074A.352.352,0,0,1,292.872,110.614Z",
    transform: "translate(-247.901 -95.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M102.42,163.3c-.069.123-.13.256-.292.284a1.941,1.941,0,0,1-.388-.672C102.067,162.9,102.2,163.178,102.42,163.3Z",
    transform: "translate(-88.317 -139.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.5,225.817c-.209-.13-.576.117-.572-.24,0-.34.3-.527.65-.527.289,0,.535.135.529.45C119.1,226,118.665,225.638,118.5,225.817Z",
    transform: "translate(-101.848 -191.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M125.327,235.049c-.243.02-.484.039-.727.057a.743.743,0,0,1,.253-.376l.68.028A.419.419,0,0,1,125.327,235.049Z",
    transform: "translate(-107.423 -199.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M546.153,97.724c-.1-.03-.277-.028-.22-.179.072-.19.274-.1.475-.113l-.233.279A.15.15,0,0,0,546.153,97.724Z",
    transform: "translate(-459.555 -84.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M550.112,95.04l.187,0c-.03.1-.036.255-.191.2C550.017,95.219,550.089,95.112,550.112,95.04Z",
    transform: "translate(-463.017 -82.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M556.968,97.988l-.069.113-.049-.046.11-.076Z",
    transform: "translate(-468.689 -85.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M557.51,96.935l.074-.205.038.02c-.035.064-.067.128-.1.194Z",
    transform: "translate(-469.241 -84.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M550.937,98.4c-.013,0-.031.015-.039.011s-.013-.025-.018-.038c.013,0,.031-.016.039-.011S550.932,98.388,550.937,98.4Z",
    transform: "translate(-463.7 -85.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M99.324,93.31c.593-.069.282.328.291.562-.128-.105-.256-.21-.384-.314.013-.062.025-.123.038-.186A.061.061,0,0,0,99.324,93.31Z",
    transform: "translate(-86.219 -81.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M167.054,225.769c0,.639-.371,1.136-.846,1.14-.36,0-.578-.264-.578-.7a1.027,1.027,0,0,1,.857-1.136C166.857,225.061,167.054,225.305,167.054,225.769Z",
    transform: "translate(-141.715 -191.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M99.49,93.335a.062.062,0,0,1-.056.062C99.419,93.347,99.435,93.324,99.49,93.335Z",
    transform: "translate(-86.385 -81.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M240.975,146.337c.415.033.622.34.821.64a.306.306,0,0,1-.057.368c-.12.133-.243.023-.347-.049-.214-.153-.419-.315-.626-.475-.1-.077-.264-.131-.2-.294S240.8,146.319,240.975,146.337Z",
    transform: "translate(-204.333 -125.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M296.608,115.6c.041-.126-.128-.447.179-.465s.4.276.4.558c0,.049,0,.1,0,.146.008.278-.053.608-.34.616-.269.008-.181-.353-.238-.553A1.241,1.241,0,0,1,296.608,115.6Z",
    transform: "translate(-251.175 -99.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.038,138.373a.268.268,0,0,1-.386.213,1.26,1.26,0,0,1-.87-.782c-.1-.3.059-.468.371-.4C248.494,137.47,249.058,138.069,249.038,138.373Z",
    transform: "translate(-210.35 -118.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M307.217,114.719c0,.033,0,.066,0,.1-.026.305-.1.639-.452.654-.391.016-.3-.389-.393-.627a.292.292,0,0,1,.007-.19c.1-.261.1-.616.473-.655C307.045,113.976,307.217,114.349,307.217,114.719Z",
    transform: "translate(-259.334 -98.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M260.241,149.587l-.067.049c-.03-.076.041-.036.062-.056Z",
    transform: "translate(-220.727 -128.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M357.5,255.15c-.1.126-.176.281-.409.24.064-.228.246-.218.409-.24Z",
    transform: "translate(-301.733 -216.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M359.586,254.008c.02-.092.041-.189.143-.222.056-.018.1.02.077.077-.033.1-.128.123-.22.145Z",
    transform: "translate(-303.819 -215.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M363.1,251.97c-.01.01-.018.021-.028.031-.011-.02-.021-.039-.033-.057.013,0,.031-.015.041-.01S363.094,251.957,363.1,251.97Z",
    transform: "translate(-306.706 -213.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.41,162.49c.062.035.118.072.1.158C94.412,162.634,94.413,162.561,94.41,162.49Z",
    transform: "translate(-82.19 -139.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M334.046,258.332l-.035.015c0-.016-.007-.034-.012-.051.013,0,.03,0,.039,0S334.044,258.32,334.046,258.332Z",
    transform: "translate(-282.435 -219.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M385.814,110.233l-.144-.184c.117.021.286-.074.333.094C386.026,110.222,385.89,110.222,385.814,110.233Z",
    transform: "translate(-325.62 -95.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M350.641,244.955c-.1.353-.406.517-.7.864a.958.958,0,0,1,.7-.869Z",
    transform: "translate(-295.758 -208.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M353.189,248.55c0,.066,0,.131,0,.2l-.2,0A.216.216,0,0,1,353.189,248.55Z",
    transform: "translate(-298.307 -211.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M354.18,244.85l.023-.02-.018.025Z",
    transform: "translate(-299.301 -207.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M265.4,152.219a.268.268,0,0,1,.3-.2A.38.38,0,0,1,265.4,152.219Z",
    transform: "translate(-225.101 -130.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M262.81,153.2c.03.061.061.122.09.181C262.778,153.366,262.729,153.315,262.81,153.2Z",
    transform: "translate(-222.903 -131.326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.26,202.484c0,.146-.074.227-.214.192a.339.339,0,0,1-.3-.371c.01-.126.084-.222.218-.2C249.175,202.136,249.224,202.313,249.26,202.484Z",
    transform: "translate(-211.178 -172.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M510.845,105.925c-.077-.025-.184.057-.235-.064l.233-.031A.145.145,0,0,1,510.845,105.925Z",
    transform: "translate(-430.043 -91.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M515.786,106.062c-.013-.008-.038-.02-.036-.025a.529.529,0,0,1,.034-.077c.013.008.039.02.038.023A.693.693,0,0,1,515.786,106.062Z",
    transform: "translate(-434.338 -91.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M349.592,223.593a.452.452,0,0,1-.419.3c-.123,0-.187-.089-.146-.2a.377.377,0,0,1,.427-.256A.132.132,0,0,1,349.592,223.593Z",
    transform: "translate(-294.984 -190.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.726,247.686c0,.113-.051.186-.171.186a.151.151,0,0,1-.161-.146.155.155,0,0,1,.168-.186A.16.16,0,0,1,333.726,247.686Z",
    transform: "translate(-281.928 -210.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.909,242.417c-.02.1-.048.2-.166.2-.141,0-.189-.105-.2-.218a.162.162,0,0,1,.164-.19C267.85,242.2,267.895,242.3,267.909,242.417Z",
    transform: "translate(-226.891 -205.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M282.384,147.19l-.2.1C282.249,147.259,282.316,147.224,282.384,147.19Z",
    transform: "translate(-239.125 -126.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M283.492,145.99c-.035.067-.067.135-.1.2C283.424,146.125,283.459,146.057,283.492,145.99Z",
    transform: "translate(-240.136 -125.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M281.093,148.39l-.1.1Z",
    transform: "translate(-238.131 -127.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M281.693,147.79l-.1.1C281.624,147.857,281.659,147.824,281.693,147.79Z",
    transform: "translate(-238.632 -126.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M122.852,104.11c.036.053.079.085.079.12,0,.067-.043.12-.113.1-.028-.01-.053-.074-.049-.112S122.813,104.156,122.852,104.11Z",
    transform: "translate(-105.892 -90.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M283.177,166.99a.389.389,0,0,1-.1.3C282.965,167.139,283.008,167.044,283.177,166.99Z",
    transform: "translate(-239.823 -142.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.79,161.042c.023-.312.148-.253.332-.107.324.258.512.675.949.795l0,0a2.572,2.572,0,0,0,.085.317c.059.145.19.31-.013.412s-.322-.041-.371-.238c.021-.018.087.025.066-.049-.021.018-.043.036-.064.053-.294-.136-.616-.23-.466-.695.056-.172-.149-.263-.324-.292l0,0a.207.207,0,0,0-.2-.2Z",
    transform: "translate(-282.26 -137.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M325.985,172.98a.449.449,0,0,1,.263.209c.076.11.15.223.061.358a.193.193,0,0,1-.214.089c-.232-.069-.028-.21-.044-.315s-.046-.223-.071-.333C325.98,172.985,325.985,172.98,325.985,172.98Z",
    transform: "translate(-275.732 -147.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.182,162.387c-.041-.025-.107-.039-.117-.074-.026-.089.059-.1.115-.123l0,0c0,.066,0,.131,0,.2Z",
    transform: "translate(-281.65 -138.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M333.987,163.39c-.023.059-.031.145-.122.117-.033-.01-.049-.077-.074-.117l0,0c.066,0,.133,0,.2,0Z",
    transform: "translate(-282.26 -139.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.6,171.559l-.079-.023c.048-.059.051.016.077.025Z",
    transform: "translate(-280.363 -146.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M326.58,170.583l.018.015-.015-.018Z",
    transform: "translate(-276.234 -145.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M303.31,194.773c0,.107-.026.194-.151.2a.141.141,0,0,1-.159-.14.2.2,0,0,1,.169-.2C303.27,194.6,303.3,194.693,303.31,194.773Z",
    transform: "translate(-256.526 -165.948)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M302.571,187.96c.094.089.261.135.2.328-.21-.023-.187-.186-.21-.319C302.56,187.971,302.571,187.96,302.571,187.96Z",
    transform: "translate(-256.158 -160.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M302.454,192.179c-.018-.036-.056-.076-.054-.113,0-.057.057-.069.094-.034a.329.329,0,0,1,.049.12Z",
    transform: "translate(-256.024 -163.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M293.533,167.58l-.013.016.015-.013Z",
    transform: "translate(-248.603 -143.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M288.522,158.593a.561.561,0,0,1-.292.555c.105-.264.03-.471.289-.558Z",
    transform: "translate(-244.182 -135.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M288.19,155.583c.016.02.031.041.048.061l-.044-.064S288.19,155.583,288.19,155.583Z",
    transform: "translate(-244.148 -133.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M283.648,148.23c-.053.034-.105.067-.159.1a.294.294,0,0,1-.039-.057c.044-.043.094-.08.143-.12C283.609,148.171,283.624,148.193,283.648,148.23Z",
    transform: "translate(-240.186 -127.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M287.648,215.915c-.24.053-.31.634-.7.22.108-.09.217-.181.327-.269C287.416,215.752,287.551,215.693,287.648,215.915Z",
    transform: "translate(-243.112 -183.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M279.19,205.555c0-.066,0-.13,0-.2.067.064.135.128.2.192A.122.122,0,0,1,279.19,205.555Z",
    transform: "translate(-236.626 -174.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M283.6,205.37q0,.148,0,.3c-.067-.067-.136-.133-.2-.2Z",
    transform: "translate(-240.145 -174.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M298.288,222.673l-.018-.023.023.018Z",
    transform: "translate(-252.573 -189.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.385,207.16c.054.016.12.021.123.1,0,.01-.02.028-.028.028-.077,0-.085-.066-.1-.122Z",
    transform: "translate(-280.246 -176.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.278,207.073l-.018-.023.025.018Z",
    transform: "translate(-280.145 -176.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M314.735,222.172c.1.033.192.079.1.2-.031.038-.145.069-.159.051-.085-.1.046-.164.064-.25Z",
    transform: "translate(-266.26 -188.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M317.5,220.972l-.02.02.018-.021Z",
    transform: "translate(-268.628 -187.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M278.693,204.863l-.1-.1Z",
    transform: "translate(-236.125 -174.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M317.6,213.77l.053.067c-.079.026-.034-.044-.053-.067Z",
    transform: "translate(-268.729 -181.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M275.528,216.612c-.039.159-.117.289-.287.289-.154,0-.164-.133-.154-.251.012-.141.072-.259.233-.259C275.457,216.39,275.513,216.489,275.528,216.612Z",
    transform: "translate(-233.194 -184.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.243,232.232c0,.135-.054.212-.161.23s-.174-.057-.182-.164.013-.232.166-.228C280.181,232.07,280.217,232.163,280.243,232.232Z",
    transform: "translate(-237.218 -197.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M290.582,202.5c0,.084-.046.125-.115.1a.253.253,0,0,1-.128-.126.094.094,0,0,1,.092-.135C290.523,202.341,290.559,202.422,290.582,202.5Z",
    transform: "translate(-245.937 -172.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M270.81,200.58a.366.366,0,0,1,.105.317c-.146-.094-.085-.217-.105-.317Z",
    transform: "translate(-229.622 -170.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M357.77,168.17l.016.026-.026-.016Z",
    transform: "translate(-302.293 -143.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M333.989,162.4h-.2c0-.066,0-.131,0-.2A.207.207,0,0,1,333.989,162.4Z",
    transform: "translate(-282.26 -138.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M339.789,169.133c.021-.018.043-.036.064-.053.021.074-.046.031-.066.049C339.786,169.129,339.789,169.133,339.789,169.133Z",
    transform: "translate(-287.272 -144.598)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 11,
    height: 4,
    transform: "translate(11.638 10.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M10.592,0A10.593,10.593,0,1,1,0,10.592,10.592,10.592,0,0,1,10.592,0Z",
    transform: "translate(36.307 17.736)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 25,
    height: 2,
    rx: 1,
    transform: "translate(25.638 20.038)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.693 34.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(-0.054 0.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 13,
    height: 1,
    rx: 0.5,
    transform: "translate(-0.054 3.069)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.045 34.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 12,
    height: 2,
    rx: 1,
    transform: "translate(-0.407 0.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 12,
    height: 1,
    rx: 0.5,
    transform: "translate(-0.407 3.069)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.163 34.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 12,
    height: 2,
    rx: 1,
    transform: "translate(0.475 0.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 12,
    height: 1,
    rx: 0.5,
    transform: "translate(0.475 3.069)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 17,
    height: 1,
    rx: 0.5,
    transform: "translate(25.638 23.038)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 2,
    cy: 2.5,
    rx: 2,
    ry: 2.5,
    transform: "translate(4.638 10.038)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 12.316,
    height: 12.316,
    transform: "translate(80.124 30.052)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 12.316,
    height: 12.316,
    transform: "translate(79.96 17.736)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 23.472,
    height: 0.928,
    transform: "translate(71.839 63.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 25.433,
    height: 0.962,
    transform: "translate(64.08 46.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.317,
    height: 0.928,
    transform: "translate(0.994 69.369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.317,
    height: 0.928,
    transform: "translate(0.994 71.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 47.612,
    height: 1.067,
    transform: "translate(0.994 73.347)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.317,
    height: 0.928,
    transform: "translate(0.994 111.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.273,
    height: 0.951,
    transform: "translate(0.994 114.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.317,
    height: 0.928,
    transform: "translate(0.994 118.881)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.317,
    height: 0.928,
    transform: "translate(0.994 76.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 94.317,
    height: 0.928,
    transform: "translate(0.994 78.871)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 70.942,
    height: 0.68,
    transform: "translate(0.994 99.692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 70.942,
    height: 0.68,
    transform: "translate(0.994 102.648)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 22.803,
    height: 1.478,
    transform: "translate(37.416 92.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 17.102,
    height: 1.795,
    transform: "translate(40.266 105.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 48.201,
    height: 2.023,
    transform: "translate(23.629 88.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 14.358,
    height: 14.358,
    transform: "translate(78.377 87.177)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 11.783,
    height: 11.783,
    transform: "translate(77.355 19.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M15.09,27.37V71.221h94.874V27.37Zm93,41.68H16.717V29.145h91.37Z",
    transform: "translate(-15.09 -26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M248.8,30.12h-3.175l.547-1.478s-.876-.712-1.15-.657-4.6,0-4.6,0a30.288,30.288,0,0,0,2.135,2.627c.6.547,1.095.931,1.095.931s-.766-.328-1.095.328-.328,2.135,1.095,2.08a2.528,2.528,0,0,0,1.971-.821l1.533.438h2.135a3.318,3.318,0,0,0,2.792,1.368,3.984,3.984,0,0,0,2.956-1.806s.712.547,1.095.438,1.7.164,1.916,0,.821,0,.821,0-.383.766.493.712,2.463,0,2.244-1.478-.657-1.642-.657-1.642l1.916-2.518.328-.657h-6.021V30.01h-2.135l-.547-1.368h-5.365l-.547,1.368",
    transform: "translate(-203.432 -26.178)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 41,
    height: 3,
    rx: 1.5,
    transform: "translate(28.445 10.038)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 31,
    transform: "translate(34.445 15.038)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurp);
export default __webpack_public_path__ + "static/media/CURP.dc5cbe718ddfb0f356b085f424cb22cf.svg";
export { ForwardRef as ReactComponent };